import i18next from 'i18next';

export const de: i18next.ResourceLanguage = {
	Account: {
		Account: 'Mein Konto',
		Email: 'E-Mail-Adresse',
		Phone: 'Telefonnummer',
		'Please enter your phone number': 'Bitte geben Sie Ihre Telefonnummer ein',
		'Please enter your email': 'Bitte geben Sie Ihre E-Mail-Adresse ein',
		'Contact details are necessary for us to be able to pass on the latest flight information.':
			'Kontaktdaten sind erforderlich, um Ihnen die neuesten Fluginformationen zukommen zu lassen.',
		'Add login through your social network account': 'Login über soziales Netzwerk hinzufügen',
		'I want to receive news and special offers': 'Ich möchte Neuigkeiten und Sonderangebote erhalten',
		'Load personal data according to the standard of GDPR':
			'Personenbezogene Daten gemäß den GDPR-Richtlinien herunterladen',
		Terms: 'Bedingungen',
		'Delete my account': 'Konto löschen',
		'Are you sure?': 'Sind Sie sicher?',
		'Are you sure you want to delete your account?': 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten?',
		'Yes, Delete account': 'Ja, Konto löschen',
		'Please enter a valid email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
		'Please enter a valid phone': 'Bitte geben Sie eine gültige Telefonnummer ein',
		'Confirmation code': 'Bestätigungscode',
		'We sent verification code to new email':
			'Wir haben einen Bestätigungscode an die neue E-Mail-Adresse gesendet',
		'We sent verification code to the phone': 'Wir haben einen Bestätigungscode an Ihre Telefonnummer gesendet',
		'Didn\'t get the code?': 'Code nicht erhalten?',
		'Resend it': 'Erneut senden',
		Orders: 'Meine Buchungen',
		'Please confirm your email': 'Bitte bestätigen Sie Ihre E-Mail-Adresse',
		'Please confirm your phone number': 'Bitte bestätigen Sie Ihre Telefonnummer',
		Confirm: 'Bestätigen',
		Save: 'Speichern',
		Send: 'Senden',
		'Travel companions': 'Reisebegleiter',
		Logout: 'Abmelden',
		'Personal details': 'Profil',
		Settings: 'Einstellungen',
		'Incorrect card number or password': 'Falsche Kartennummer oder falsches Passwort',
		'Loyalty program': 'Vielfliegerprogramm',
		FFP: 'Vielfliegerprogramm',
		'Loyalty card number': 'Vielfliegerkartennummer',
		Password: 'Passwort',
		'Client support': 'Kundensupport',
		No: 'No',
		'Log out': 'Abmelden',
		'Phone is already in use by another account':
			'Diese Telefonnummer wird bereits von einem anderen Konto verwendet',
		'Email is already in use by another account':
			'Diese E-Mail-Adresse wird bereits von einem anderen Konto verwendet',
		'Failed to fetch': 'Fehler beim Abrufen',
		'Oops...': 'Ups...',
		'OK, thank you': 'OK, danke',
		'An error occurred while executing the request. Please try again later or contact a customer support service.':
			'Beim Ausführen der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Kundenservice.',
		'Error on confirming': 'Bestätigungscode ist ungültig',
		'My cabinet': 'Menü',
		'Orders that were booked on a previous version of the site are available':
			'Buchungen aus der vorherigen Version der Website sind verfügbar unter',
		'this link': 'diesem Link',
		'Operations history': 'Transaktionsverlauf',
		Date: 'Datum',
		Operation: 'Vorgang',
		Balance: 'Kontostand',
		'Status miles': 'Statusmeilen',
		Assessed: 'Gutgeschrieben',
		'Add booking': 'Buchung hinzufügen',
		'Ticket or booking number': 'Ticket- oder Buchungsnummer',
		'Online check-in': 'Online Check-in',
		'Search flights': 'Flüge suchen',
		'I have a booking': 'Ich habe eine Buchung',
		'Check-in': 'Check-in für den Flug',
		'How to find a booking id?': 'Wie finde ich die Buchungsnummer?',
		'Check-in conditions': 'Bedingungen für den Check-in',
		Cancel: 'Abbrechen',
		Continue: 'Weiter',
		'Last name': 'Nachname',
		'Enter the passengers surname (in latin characters) and ticket number, order ID or booking ID. You can find these in the itinerary receipt sent to purchasers Email after booking.':
			'Geben Sie den Nachnamen des Passagiers (in lateinischen Buchstaben) und die Ticketnummer, Bestellnummer oder Buchungsnummer ein. Diese finden Sie in der Reisebestätigung, die nach der Buchung an Ihre E-Mail-Adresse gesendet wurde.',
		'Online check-in opens 30 hours and closes 50 minutes before departure':
			'Der Online-Check-in öffnet 30 Stunden und schließt 50 Minuten vor Abflug.',
		'Baggage claim closes 40 minutes before flight departure. Please, check that your hand luggage weight is up to 10 kg and size does not exceed 55x40x23 cm':
			'Die Gepäckabgabe schließt 40 Minuten vor Abflug. Bitte stellen Sie sicher, dass Ihr Handgepäck nicht mehr als 10 kg wiegt und die Maße 55×40×23 cm nicht überschreitet.',
		'Please, make sure te passenger is not included in special category':
			'Bitte stellen Sie sicher, dass der Passagier keiner Sonderkategorie zugeordnet ist.',
		'Purchase for miles': 'Mit Meilen bezahle',
		'Please fill in the missing fields': 'Bitte füllen Sie die fehlenden Felder aus',
		'Confirm your contacts': 'Kontaktdaten bestätigen',
		'Set your preferences': 'Einstellungen festlegen',
		'Add your phone number': 'Telefonnummer hinzufügen',
		'Keep building my profile': 'Profil weiter vervollständigen',
		'Enter your name': 'Bitte geben Sie Ihren Namen ein',
		'Welcome!': 'Willkommen!',
		'Usually traveling with a friend or family?': 'Reisen Sie häufig mit Freunden oder Familie?',
		'Add them to your companions list and make checking-in altogether easier.':
			'Fügen Sie sie Ihrer Begleiterliste hinzu, um den Check-in zu erleichtern.',
		Passengers: 'Passagiere',
		'Add companion': 'Begleiter hinzufügen',
		'Next flights': 'Nächster Flug',
		'My office': 'Mein Bereich',
		Home: 'Startseite',
		'Login settings': 'Login-Einstellungen',
		'Social networks accounts': 'Soziale Netzwerke',
		'Mail settings': 'E-Mail-Einstellungen',
		Profile: 'Profil',
		Edit: 'Bearbeiten',
		Miles: 'Meilen',
		Communications: 'Kommunikation',
		Connect: 'Verbinden',
		Connected: 'Verbunden',
		'Not connected': 'Nicht verbunden',
		'Email will be removed from your login methods': 'Die E-Mail {{email}} wird aus den Anmeldemethoden entfernt',
		'Phone will be removed from your login methods':
			'Die Telefonnummer {{phone}} wird aus den Anmeldemethoden entfernt',
		'FFP will be removed from your login methods':
			'Die Vielfliegerkarte {{ffp}} wird aus den Anmeldemethoden entfernt',
		'Login method removal': 'Anmeldemethode entfernen',
		Remove: 'Entfernen',
		'method will be removed from your login methods': '{{method}} wird aus den Anmeldemethoden entfernt',
		'Add a new login method': 'Neue Anmeldemethode hinzufügen',
		Add: 'Hinzufügen',
		'A confirmation code will be sent to your address': 'Ein Bestätigungscode wird an Ihre E-Mail-Adresse gesendet',
		'A confirmation code will be sent to your phone': 'Ein Bestätigungscode wird an Ihre Telefonnummer gesendet',
		'Change login method': 'Anmeldemethode ändern',
		'Error on sending secure code': 'Fehler beim Senden des Codes',
		'Email for notification': 'E-Mail für Benachrichtigungen'
	},
	AdditionalBaggage: {
		'More bags?': 'Mehr Gepäck?',
		'Buy now and save 20-30%': 'Jetzt kaufen und 20–30 % sparen',
		'Check-in bags': 'Aufgegebenes Gepäck',
		'Leave them at the check-in desk. Up to 3 bags per passenger. Price per flight.':
			'Abgabe am Check-in-Schalter. Bis zu 3 Gepäckstücke pro Passagier. Preis pro Flug.',
		Add: 'Hinzufügen',
		from: 'ab',
		Edit: 'Bearbeiten',
		total: 'Gesamt',
		'Check-in baggage': 'Aufgegebenes Gepäck',
		'More baggage for you': 'Zusätzliches Gepäck für Sie',
		Overweight: 'Übergepäck',
		'Need to add another 10-30 kg to your total checked baggage?':
			'Möchten Sie weitere 10–30 kg zu Ihrem Aufgabegepäck hinzufügen?'
	},
	AdditionalServiceCard: {
		Add: 'Hinzufügen',
		Remove: 'Entfernen',
		Insurance: 'Entfernen',
		Transfer: 'Entfernen',
		'Terms of service': 'Nutzungsbedingungen ',
		Select: 'Auswählen',
		Selected: 'Auswählen',
		'Enter document number': 'Geben Sie die ID-Nummer ein',
		Required: 'Pflichtfeld',
		'Only digits': 'Bitte 12 Ziffern eingeben',
		Done: 'Fertig',
		Clear: 'Löschen'
	},
	AdditionalServiceWrapper: {
		'Full conditions': 'Alle Bedingungen',
		Cancel: 'Abbrechen',
		Ok: 'Bestätigen',
		Clear: 'Löschen',
		Confirm: 'Bestätigen',
		Total: 'Gesamt'
	},
	AddPassenger: {
		'Add passenger': 'Passagier hinzufügen',
		'Passenger last name': 'Nachname des Passagiers',
		'Ticket number or booking reference': 'Ticketnummer oder Buchungsreferenz',
		'Ticket number': 'Ticketnummer',
		Find: 'Suchen',
		'Required field': 'Pflichtfeld',
		'Passenger not found': 'Passagier nicht gefunden'
	},
	Aeroexpress: {
		ToAirport: 'Zum Flughafen-Tarif',
		'To airport': 'Zum Flughafen',
		FromAirport: 'Vom Flughafen',
		'No worries about traffic jams, arrival at the airport strictly on schedule':
			'Keine Sorge wegen Staus – die Ankunft am Flughafen erfolgt genau nach Fahrplan',
		Add: 'Hinzufügen',
		'Fast and convenient': 'Schnell und bequem',
		Transfer: 'Aeroexpress',
		seat_0: '{{count}} Sitzplatz',
		seat_1: '{{count}} Sitzplätze',
		seat_2: '{{count}} Sitzplätze',
		ticket_0: '{{count}} Ticket',
		ticket_1: '{{count}} Ticket',
		ticket_2: '{{count}} Tickets',
		Cancel: 'Stornieren',
		Total: 'Gesamt: ',
		From: 'ab',
		'View schedule': 'Fahrplan anzeigen',
		Terms: 'Bedingungen',
		Change: 'Ändern',
		Done: 'Fertig',
		Clear: 'Löschen',
		'Download tickets': 'Tickets herunterladen',
		standart: 'Standard-Klasse Tarif',
		business: 'Business-Klasse Tarif',
		Download: 'Herunterladen',
		full: 'Standard-Klasse Tarif',
		roundtrip: 'Hin- und Rückfahrt',
		Roundtrip: 'Hin- und Rückfahrt-Klasse Tarif',
		To: 'bis'
	},
	Aircraft: {
		Embraer: 'Embraer',
		'E190 E2': 'E190 E2',
		Economy: 'Embraer-Klasse Tarif',
		Business: 'Business-Klasse Tarif',
		Premium: 'Premium-Klasse Tarif',
		'Seat pitch': 'Sitzabstand',
		'Up to': 'Bis zu',
		'"': '"',
		'Seat width': 'Sitzbreite',
		'Seat recline': 'Sitzlehne verstellbar',
		'The Embraer E-Jet E2 family are medium-range jet airliners developed by Embraer, succeeding the original E-Jet. The program was launched at the Paris Air Show in 2013. The first variant, the E190-E2, took its first flight on 23 May 2016 and was certified on February 28, 2018 before entering service with Widerøe on 24 April. The three twinjet variants share the same four-abreast narrow-body fuselage with different lengths and three different new wings, Pratt & Whitney PW1000G turbofans in two sizes, fly-by-wire controls with new avionics, and an updated cabin.':
			'Die Embraer E-Jet E2-Familie sind Mittelstreckenstrahlflugzeuge, entwickelt von Embraer als Nachfolger des ursprünglichen E-Jet. Das Programm wurde auf der Pariser Luftfahrtmesse 2013 gestartet. Die erste Variante, der E190-E2, absolvierte seinen Erstflug am 23. Mai 2016 und wurde am 28. Februar 2018 zertifiziert, bevor er am 24. April bei Widerøe in Dienst gestellt wurde. Die drei Twinjet-Varianten teilen sich den gleichen schmalen Rumpf mit vier Sitzen nebeneinander, unterscheiden sich in der Länge, verfügen über drei verschiedene neue Flügel, Pratt & Whitney PW1000G-Turbofans in zwei Größen, Fly-by-Wire-Steuerung mit neuer Avionik und eine aktualisierte Kabine.',
		Max: 'Max',
		nmi: 'nmi',
		ft: 'ft',
		cm: 'sm',
		'National origin': 'Herkunft',
		Brasil: 'Brasilien',
		Manufacturer: 'Hersteller',
		Status: 'Status',
		'In service': 'Im Einsatz',
		Produced: 'Produziert',
		'Flight deck crew': 'Cockpitbesatzung',
		'2 pilots': '2 Piloten',
		'Seating, dual class': 'Bestuhlung, Zweiklassen',
		'96 12j @38in': '96 12j @38in',
		'18.3 in (46 cm)': '18.3 in (46 cm)',
		Length: 'Länge',
		'36.24 m': '36.24 м.',
		Wingspan: 'Flügelspannweite',
		'33.72 m': '33.72 м.',
		Speed: ' Geschwindigkeit',
		'Mach 0.82 (473 kn; 876 km/h) Max': 'Mach 0,82 (473 kn; 876 km/h) Max',
		'Range (full pax)': 'Reichweite (volle Passagierzahl)',
		'3,250 nmi (6,020 km)': '3.250 nmi (6.020 km)',
		'Service ceiling': 'Dienstgipfel',
		'41,000 ft (12,000 m)': '41.000 ft (12.000 m)',
		Engines: 'Triebwerke',
		'2× Pratt & Whitney PW1919G/21G/22G/23G': '2× Pratt & Whitney PW1919G/21G/22G/23G',
		Title_PassengerCapacity: 'Kapazität',
		Title_CruisingSpeed: 'Reisegeschwindigkeit',
		Title_MaxFlightRange: 'Maximale Reichweite',
		Unit_PassengerCapacity: 'Sitzplätze',
		Unit_CruisingSpeed: 'km/h',
		Unit_MaxFlightRange: 'km'
	},
	Airport: {
		'Open web site': 'Website öffnen',
		Departures: 'Abflüge',
		Arrivals: 'Ankünfte',
		Summary: 'Information',
		Services: 'Dienstleistungen',
		Map: 'Karte'
	},
	BaggagePage: {
		Baggage: 'Багаж',
		'Transportation of impressions no limitations': 'Провоз впечатлений\nнеограничен',
		'Baggage rules': 'Правила провоза багажа',
		Adult: 'Взрослый',
		Child: 'Ребенок',
		Infant: 'Младенец'
	},
	BaggageTotalPriceBlock: {
		Add: 'Hinzufügen',
		edit: 'Bearbeiten',
		from: 'Ab',
		'More bags': 'Zusätzliches Gepäck'
	},
	Cart: {
		Flights: 'Flüge',
		Baggage: 'Gepäck',
		Seats: 'Sitzplätze',
		Meal: 'Mahlzeit',
		Passengers: 'Passagiere',
		Contacts: 'Kontakte',
		'All flights': 'Alle Flüge',
		Total: 'Gesamt',
		Close: 'Schließen',
		ADT: 'Erwachsener',
		CLD: 'Kind',
		INF: 'Kleinkind ',
		INS: 'Kleinkind mit Sitzplatz',
		Extra: 'Zusatzleistung',
		Aeroexpress: 'Aeroexpress',
		Insurances: 'Versicherungen',
		'Business lounge': 'Business-Lounge',
		'The service you have added cannot be activated. Try connecting later or contact the airline operator.':
			'Der von Ihnen hinzugefügte Service kann nicht aktiviert werden. Versuchen Sie es später erneut oder wenden Sie sich an die Fluggesellschaft.',
		'The service is awaiting confirmation. Do not close or refresh the window.':
			'Der Service wartet auf Bestätigung. Bitte schließen oder aktualisieren Sie das Fenster nicht.'
	},
	Checkin: {
		'Oops, something went wrong': 'Ups, etwas ist schiefgelaufen',
		'But don\'t worry, all of our systems have been duplicated several times. You can register on the backup version of the site.':
			'Keine Sorge, all unsere Systeme wurden mehrfach dupliziert. Sie können sich auf der Backup-Version der Website registrieren.',
		Go: 'Zur Backup-Website gehen',
		'Try again': 'Erneut versuchen',
		From: 'Von',
		'Please, enter your contacts': 'Bitte geben Sie Ihre Kontaktdaten ein',
		'Ticket number or booking reference': 'Ticketnummer oder Buchungscode',
		'Inflight insurance or baggage insurance is your travel confidence.':
			'Flug- oder Gepäckversicherung – Ihre Sicherheit auf Reisen.',
		'Checkin canceled, you will be redirected to the beginning':
			'Check-in abgebrochen, Sie werden zum Anfang weitergeleitet',
		'Passenger last name': 'Nachname des Passagiers',
		'Oops...': 'Ups...',
		Continue: 'Weiter',
		'OK, thank you': 'OK,klar, danke',
		'An unexpected error has occurred during the start of the check-in process. Please try again later or contact a customer support service.':
			'Beim Start des Check-ins ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Kundenservice.',
		'Online check-in': 'Online-Check-in',
		Passengers: 'Passagiere',
		Next: 'Weiter',
		'Find booking': 'Buchung suchen',
		Baggage: 'Gepäck',
		Seats: 'Sitzplatzwahl',
		Meal: 'Verpflegung',
		Payment: 'Zahlung',
		'Boarding pass': 'Boardingpass',
		'Choose passengers for check-in': 'Wählen Sie Passagiere für den Check-in aus',
		'How to find a booking?': 'Wie finde ich eine Buchung?',
		'Enter the passenger last name (in latin characters) and the booking code. \nYou can find it in the itinerary receipt sent to your email after booking.':
			'Geben Sie den Nachnamen des Passagiers (lateinische Buchstaben) und den Buchungscode ein.\nSie finden diesen in der Buchungsbestätigung, die Ihnen per E-Mail zugesendet wurde.',
		'Incorrect last name or booking code': 'Falscher Nachname oder Buchungscode',
		'Check-in Successful': 'Check-in erfolgreich',
		'Sorry,': 'Leider,',
		'online check-in is closed for this flight': 'der Online-Check-in für diesen Flug ist geschlossen',
		OK: 'OK',
		'You can now download and print your boarding passes. You will need them at the airport.':
			'Sie können nun Ihre Boardingpässe herunterladen und ausdrucken. Sie benötigen diese am Flughafen.',
		'An error occurred during the check-in process. Please try again later or contact a customer support service.':
			'Beim Check-in ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Kundenservice.',
		'Anything else for your trip?': 'Möchten Sie noch etwas zu Ihrer Reise hinzufügen?',
		Extras: 'Zusatzleistungen',
		'Online check-in will close at': 'Der Online-Check-in schließt um',
		'To complete online check-in you must choose seats for all passengers on all flight directions':
			'Um den Online-Check-in abzuschließen, müssen Sie Sitzplätze für alle Passagiere auf allen Flugstrecken auswählen',
		'Unfortunately, check-in cancellation is prohibited for this flight. Please contact a customer support service for further details.':
			'Leider ist die Stornierung des Online-Check-ins für diesen Flug nicht erlaubt. Bitte wenden Sie sich für weitere Informationen an den Kundenservice',
		'Please, enter your visa details': 'Bitte geben Sie Ihre Visadaten ein',
		Save: 'Speichern',
		Download: 'Herunterladen',
		'Go to home': 'Zur Startseite',
		'Business lounge': 'Business-Lounge',
		from: 'ab',
		Change: 'Ändern',
		'No visa required': 'Überspringen',
		'Start online check-in': 'Online-Check-in starten',
		'Last name': 'Nachname',
		'Ticket / booking number': 'Ticket- / Buchungsnummer',
		'Booking not found':
			'Buchung nicht gefunden. Bitte überprüfen Sie die eingegebenen Daten oder nutzen Sie die Ticketnummer zur Identifikation.',
		Required: 'Pflichtfeld',
		'Incorrect value': 'Ungültiger Wert',
		'How to find a booking id?': 'Wie finde ich meine Buchungsnummer?',
		HelpBookingFind:
			'Geben Sie den Nachnamen des Passagiers (lateinische Buchstaben) sowie die Ticketnummer, Bestellnummer oder Buchungsnummer ein.\r\nDiese finden Sie in der Reiseroute, die Ihnen nach der Buchung per E-Mail zugeschickt wurde.',
		Conditions: 'Bedingungen',
		Add: 'Hinzufügen',
		Cancel: 'Abbrechen',
		'airport local time': 'nach Ortszeit des Flughafens',
		'Seats have already been assigned by the airline and check-in is only available at the counter at the airport':
			'Sitzplätze wurden bereits von der Fluggesellschaft zugewiesen. Der Check-in ist nur am Schalter im Flughafen möglich.',
		Attention: 'Achtung',
		Close: 'Schließen',
		'Invalid seat number':
			'Online-Check-in für Sitzplatz {{seatNumber}} ist nicht möglich. Bitte checken Sie am Flughafenschalter ein.',
		'You can now download and print your boarding passes. You will need them at the airport.\n Please notice, for flight {{flight}} you must receive your boarding pass at the airport':
			'Sie können nun Ihre Boardingpässe herunterladen und ausdrucken. Sie benötigen diese am Flughafen.\n Bitte beachten Sie, dass für den Flug {{flight}} der Boardingpass nur am Flughafen erhältlich ist',
		'You can now download and print your boarding passes. You will need them at the airport.\n Please notice, for flight {{flight}} you must receive your boarding pass at the airport_1':
			'Sie können nun Ihre Boardingpässe herunterladen und ausdrucken. Sie benötigen diese am Flughafen.\n Bitte beachten Sie, dass für die Flüge {{flight}} die Boardingpässe nur am Flughafen erhältlich sind.',
		'Service is temporarily unavailable. There are no seats available. Please try again later, or check in at the airport.':
			'Der Dienst ist vorübergehend nicht verfügbar. Es sind keine Sitzplätze verfügbar. Bitte versuchen Sie es später erneut oder checken Sie am Flughafen ein.',
		'Checkin available only in airport': 'Online-Check-in ist nicht verfügbar. Check-in nur am Flughafen möglich.',
		'You cannot add a passenger because the currency of order is different from the currency of orders of previously added passengers.\nYou can check-in the passenger separately.':
			'Sie können keinen weiteren Passagier hinzufügen, da die Währung seiner Buchung von der Währung der bereits hinzugefügten Passagiere abweicht.\nSie können ihn separat einchecken'
	},
	CheckinAddDocuments: {
		Submit: 'Speichern',
		'Add documents': 'Dokumente hinzufügen'
	},
	CheckinConditions: {
		'Check-in conditions': 'Check-in-Bedingungen',
		OpenCloseCheckinCondition: 'Der Online-Check-in öffnet 30 Stunden und schließt 50 Minuten vor Abflug',
		BaggageCondition:
			'Die Gepäckaufgabe schließt 40 Minuten vor Abflug. Bitte stellen Sie sicher, dass Ihr Handgepäck nicht mehr als 10 kg wiegt und die Maße 55x40x23 cm nicht überschreitet',
		PassengersCondition: 'Stellen Sie sicher, dass der Passagier keiner Sonderkategorie angehört',
		Rules_0: 'Der Online-Check-in öffnet 24 Stunden und schließt 1 Stunde vor dem Abflug.',
		Rules_1:
			'Bitte stellen Sie sicher, dass Gewicht und Maße Ihres Handgepäcks den Beförderungsbestimmungen entsprechen.',
		Rules_2: 'Bitte stellen Sie sicher, dass Ihr Passagier keiner besonderen Kategorie angehört.'
	},
	CheckinRules: {
		Continue: 'Weiter',
		'Terms & Conditions': 'Allgemeine Geschäftsbedingungen für den Online-Check-in',
		'I have read and agreed to the online check-in terms and conditions':
			'Ich habe die Allgemeinen Geschäftsbedingungen für den Online-Check-in gelesen und akzeptiere sie.',
		'Please read and accept the online check-in terms and conditions':
			'Bitte lesen und akzeptieren Sie die Allgemeinen Geschäftsbedingungen für den Online-Check-in.'
	},
	Checkout: {
		'Review your trip': 'Ihre Buchung',
		'LOUNGE ACCESS': 'Lounge-Zugang',
		'PRE RESERVED SEAT ASSIGNMENT': 'Sitzplatzreservierung',
		Details: 'Details',
		'Miles will be credited to your account after the flight.':
			'Meilen werden Ihrem Konto nach dem Flug gutgeschrieben.',
		'Start earning miles now to flight cheaper': 'Sammeln Sie jetzt Meilen, um günstiger zu fliegen',
		Register: 'Registrieren',
		'View status': 'Status anzeigen',
		'{{number}} {{miles}} will be awarded': '{{number}} {{miles}} werden gutgeschrieben',
		miles: 'Meilen',
		miles_0: 'Meile',
		miles_1: 'Meilen',
		miles_2: 'Meilen',
		'Light Jet Club': 'Websky Club',
		'Get our latest offers': 'Exklusive Angebote für Sie',
		Cancel: 'Stornieren',
		'Sign up for NORDWIND newsletter and enjoy invites to major sales and exclusive offers and always be in the know.':
			'Abonnieren Sie den Newsletter von Nordwind Airlines und erhalten Sie Einladungen zu großen Verkaufsaktionen, exklusive Angebote und bleiben Sie immer informiert.',
		'I accept the': 'Ich akzeptiere die...',
		'terms of agreement': 'Allgemeinen Geschäftsbedingungen',
		'terms of insurances': 'Versicherungsbedingungen',
		'Sorry, the price has changed to': 'Leider hat sich der Preis geändert auf',
		'Wow, the price has changed to': 'Wow, der Preis ist gefallen auf',
		'We recommend buying your tickets now to avoid another price increase.':
			'Die Preise können jederzeit steigen – zögern Sie nicht mit dem Kauf!',
		'Sorry, flight is either not available or sold out':
			'Leider ist dieser Flug nicht mehr verfügbar oder ausgebucht',
		'Please, choose another flight.': 'Bitte wählen Sie einen anderen Flug.',
		'Choose another flight': 'Anderen Flug wählen',
		'old price': 'alter Preis',
		'Change flight': 'Flug ändern',
		Continue: 'Weiter',
		Required: 'Pflichtfeld',
		'Please, read the rules of service and accept it':
			'Bitte lesen und akzeptieren Sie die Servicebedingungen, um fortzufahren',
		Seats: 'Sitzplätze',
		Baggage: 'Gepäck',
		Meal: 'Verpflegung',
		'Select seats': 'Sitzplätze auswählen',
		'Select meal': 'Mahlzeit auswählen',
		'Checked-in baggage': 'Aufgegebenes Gepäck',
		Adult: 'Erwachsener',
		Child: 'Kind',
		Infant: 'Kleinkind',
		Status: 'Buchungsstatus',
		'Payment details': 'Zahlungsdetails',
		Service: 'Dienstleistung',
		'processing of my personal data': 'den Bedingungen der Datenverarbeitung',
		'general transportation rules': 'den allgemeinen Beförderungsbedingungen',
		'and I accept it. I am aware that the fee for unused additional services is not refundable.':
			'und akzeptiere sie. Ich bin darüber informiert, dass Gebühren für nicht genutzte Zusatzleistungen nicht erstattet werden.',
		and: 'und',
		Price: 'Preis',
		Total: 'Gesamt',
		Booked: 'Gebucht',
		Cancelled: 'Storniert',
		Confirmed: 'Bestätigt',
		New: 'Neu',
		'Thank you for your booking!': 'Buchung erfolgreich abgeschlossen!',
		Back: 'Zurück',
		'Priority boarding': 'Bevorzugtes Einsteigen',
		Insurance: 'Versicherung',
		Transfer: 'Transfer',
		Aeroexpress: 'Aeroexpress',
		Flight: 'Flug',
		Flights: 'Flüge',
		'Selected options': 'Ausgewählte Flüge',
		Clarification: 'Wichtiger Hinweis',
		'Skip the line at the gate and board the aircraft early.':
			'Umgehen Sie die Warteschlange am Gate und steigen Sie frühzeitig ein.',
		'Guaranteed overhead baggage space.': 'Garantierter Stauraum für Handgepäck',
		'More time to get comfortable on board.': 'Früher einsteigen als alle anderen Passagiere',
		'Coverage for medical expenses, also suitable for visa. Business lounge in case of delay. Get 30 miles':
			'Versicherungsschutz bei medizinischen Kosten und Visafällen. Zugang zur Business-Lounge bei Verspätung. 30 Meilen Bonus.',
		'No worries about traffic jams, arrival at the airport strictly on schedule.':
			'Keine Sorge wegen Staus – Transfer pünktlich vom Flughafen ins Stadtzentrum.',
		'Be among the first to board': 'Unter den Ersten einsteigen',
		'Basic Packet': 'Basispaket',
		'Fast and convenient': 'Schnell und bequem',
		'Are you sure you are ready to remove insurance?':
			'Sind Sie sicher, dass Sie auf die Versicherung verzichten möchten?',
		'Inflight insurance or baggage insurance is your travel confidence.':
			'Reiseversicherung oder Gepäckversicherung – Ihre Sicherheit auf Reisen.',
		'Flying with risk': 'Ich trage alle Risiken selbst',
		Insure: 'Versicherung aktivieren',
		Add: 'Hinzufügen',
		'Download policy': 'Police herunterladen',
		'Show details': 'Details anzeigen',
		'Hide details': 'Details ausblenden',
		'Go to online check-in': 'Zum Online-Check‑in',
		'Change / Refund': 'Ändern / Rückerstattung',
		'Tickets have been sent to {{email}}': 'Tickets wurden an {{email}} gesendet',
		'Resend it': 'Erneut senden',
		'Enjoy the extended range of dishes and top-notch services on board, earn extra miles':
			'Genießen Sie erweiterte Bordverpflegung und Premium-Services, sammeln Sie zusätzliche Meilen',
		Passengers: 'Passagiere',
		'Oops...': 'Ups...',
		'OK, thank you': 'Alles klar, danke',
		'An unexpected error has occurred during the booking process. Please try again later or contact a customer support service.':
			'Beim Buchungsvorgang ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Kundenservice.',
		'An unexpected error has occurred during the tickets downloading process. Please try again later or contact a customer support service.':
			'Beim Herunterladen der Tickets ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie unseren Kundenservice.',
		Send: 'Senden',
		Email: 'E-Mail',
		'Resend booking': 'Buchung erneut senden',
		'Failed to send tickets to the specified mail, try again later':
			'Tickets konnten nicht an die angegebene E-Mail gesendet werden. Bitte später erneut versuchen.',
		'Please enter a valid email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
		'Select seat': 'Sitzplatz auswählen',
		'If you will not select a seat now, we will automatically select it for you upon check-in.':
			'Wenn Sie jetzt keinen Sitzplatz wählen, erfolgt die Auswahl automatisch beim Check‑in.',
		'Next step': 'Zum nächsten Schritt',
		'Now you will be redirected to the previous version of the site. There you can choose ancillary services.':
			'Sie werden jetzt zur Vorgängerversion der Seite weitergeleitet. Dort können Sie Zusatzleistungen auswählen.',
		'Add now': 'Jetzt Dienstleistungen auswählen',
		'Order has been cancelled': 'Bestellung wurde storniert',
		'Your special comfort on board': 'Ihr besonderer Komfort an Bord',
		'Improve your flight right now by adding the pleasant and necessary comfort with special food, extra baggage and the best places with amazing views.':
			'Machen Sie Ihren Flug unvergesslich – mit Gourmet-Verpflegung, Zusatzgepäck und den besten Sitzplätzen mit Ausblick.',
		Resend: 'Erneut senden',
		'Thank you for your choice. All need documents has been sent to your e-mail address.':
			'Vielen Dank für Ihre Auswahl. Alle notwendigen Unterlagen wurden an Ihre E-Mail-Adresse gesendet.',
		'Paid by credit card': 'Mit Kreditkarte bezahlt',
		'Waiting for payment expires at': 'Zahlungserwartung läuft ab um',
		Ref: 'Bestell-Nummer',
		'Security code': 'Sicherheitscode',
		Download: 'Herunterladen',
		'Price details': 'Gesamt',
		'Baggage rules': 'Gepäckbestimmungen Regeln',
		'Feel the taste in flight!': 'Genießen Sie den Geschmack an Bord!',
		'Transportation of impressions no limitations': 'Erfahrungen transportieren ohne Limit',
		'The top ones get the top seats!': 'Die besten Plätze bekommen die Ersten!',
		'Fly in comfort': 'Komfortabel fliegen',
		from: 'ab',
		Change: 'Ändern',
		Refund: 'Rückerstattung',
		Exchange: 'Umtausch',
		'Seat selection is available in the online registration service':
			'Sitzplatzauswahl im Online-Registrierungsservice verfügbar',
		'You can select seats using the online registration service after issuing tickets':
			'Nach Ticketausstellung können Sie über den Online-Check‑in Sitzplätze auswählen.',
		'Business lounge': 'Business-Lounge',
		'The flight is available, hurry up with booking!': 'Flug verfügbar – buchen Sie schnell!',
		'Attention, times have changed for flight {{route}}': 'Achtung, Zeiten für Flug {{route}} haben sich geändert',
		'More details': 'Weitere Details',
		'Capsule hotel': 'Kapselhotel',
		'per person': 'por Person',
		'Full conditions': 'Komplette Bedingungen',
		'Total for all passengers': 'Gesamt für alle Passagiere',
		Aeroexpress_Cancel: 'Stornierung',
		Ok: 'OK',
		Class_full: 'Ganz Standard-Klassetarif',
		Class_business: 'Business-Klassetarif',
		Class_child: 'Kinder-Klassetarif',
		Class_family: 'Familie-Klassetarif',
		Class_couple: 'Paar-Klassetarif',
		Class_standart: 'Standart-Klassetarif',
		Class_roundtrip: 'Hin- und Rückflug-Klassetarif',
		Class_business_roundtrip: 'Business Hin- und Rückflug-Klassetarif',
		ToAirport: 'Hinflug Strecke Tarif',
		FromAirport: 'Hinflug Strecke Tarif',
		Roundtrip: 'Hin- und Rückflug Strecke Tarif',
		'And back': 'und zurück',
		'Aeroexpress tickets are valid for 30 days.': 'Aeroexpress-Tickets sind 30 Tage gültig.',
		'passenger conduct rules': 'Verhaltensregeln für Passagiere',
		'terms of tariff': 'Tarifbedingungen',
		'Search my booking': 'Meine Buchung suchen',
		Done: 'Fertig',
		'Passenger not found. Please, check passenger last name and ticket number':
			'Passagier nicht gefunden. Bitte überprüfen Sie Nachname und Ticketnummer.',
		'Add passenger': 'Passagier hinzufügen',
		'Add your travel companion to the order? Add ticket':
			'Reisebegleiter zur Bestellung hinzufügen? Ticket ergänzen',
		'price for all persons': 'Preis für alle Personen',
		Select: 'Auswählen',
		Reject: 'Ablehnen',
		'SMS notifications': 'SMS-Benachrichtigungen',
		Clear: 'Löschen',
		'Open the full text of the conditions of carriage': 'Kompletten Wortlaut der Beförderungsbedingungen öffnen',
		Animal: 'Haustier',
		'All payments will be charged in Russian rubles. The amounts indicated in other currencies are presented as a guideline.':
			'Alle Zahlungen erfolgen in russischen Rubel. Beträge in anderen Währungen dienen nur zur Orientierung.',
		'Only 1 animal is allowed per adult passenger.': 'Pro erwachsenem Passagier ist nur 1 Tier erlaubt.',
		'Placement of passengers with an animal in the front rows is prohibited.':
			'Sitzplätze vorn mit Haustier sind nicht erlaubt.',
		'Specify all passengers for whom you need to open an order for correct display.':
			'Geben Sie alle Passagiere an, für die eine Bestellung geöffnet werden soll, um eine korrekte Anzeige zu gewährleisten.',
		'View old booking': 'Verknüpfte Buchung anzeigen',
		'Order created from': 'Bestellung erstellt ab',
		'You must select seats to proceed to the next step':
			'Sie müssen Sitzplätze auswählen, um zum nächsten Schritt zu gelange',
		'All flight': 'Alle Flüge',
		'Promo code': 'Promo-Code',
		Passenger: 'Passagier',
		'Original price': 'Originalpreis',
		'Final price': 'Endpreis',
		'Total price': 'Gesamtpreis',
		'Correct promo codes': 'Promocodes korrigieren',
		'Check if the promo code is entered correctly or contact the call center of the airline':
			'Keine Rabatte verfügbar. Bitte überprüfen Sie die Eingabe des Promocodes oder wenden Sie sich an das Callcenter der Fluggesellschaft.',
		'Add services': 'Zusatzleistungen',
		Error: 'Fehler',
		'An error occurred while checking the promo code, change the promo code or continue without it':
			'Fehler bei der Überprüfung des Promocodes. Bitte ändern Sie ihn oder fahren Sie ohne fort.',
		'Promo codes not available': 'Promocodes nicht verfügbar',
		'We recommend using extra baggage': 'Wir empfehlen die Zusatzleistung "{{name}}" für zusätzliches Gepäck',
		'Extra delivery baggage': 'Nutzen Sie unseren neuen Service\n"{{name}}" – reisen Sie unbeschwert!',
		'Extra delivery baggage free for dates': 'Kostenlos für Flüge vom 18.04.24 bis 20.04.24',
		Refuse: 'Ablehnen',
		Agree: 'Leistung hinzufügen',
		Remove: 'Entfernen',
		'Prices are for all passengers, including taxes and fees. By local time.':
			'Preise gelten für alle Passagiere inklusive Steuern und Gebühren. Ortszeit.',
		'Error from supplier. Passenger\'s name and/or surname is too long':
			'Der Vor- und/oder Nachname des Passagiers ist zu lang',
		Confirm: 'Bestätigen',
		'Extra comfort': 'Zusätzlicher Komfort',
		'VIP lounges, business lounges, priority pre-flight procedures':
			'VIP-Lounges, Business-Lounges, bevorzugte Abfertigung vor dem Flug',
		'To book': 'Buchen',
		'Your order was archived. Please contact with client support to get a receipt':
			'Die Buchung wurde archiviert. Bitte wenden Sie sich an den Kundensupport, um Ihre Reisedokumente zu erhalten.',
		pet_popup_rules: [
			'Wir befördern im Passagierraum: Hunde, Katzen sowie Vögel.',
			'Das Gewicht des Transportbehälters inklusive Tier darf 8 kg nicht überschreiten.',
			'Die Abmessungen eines festen Behälters (Käfigs) dürfen 60×35×20 cm (L×B×H) nicht überschreiten.',
			'Die Gesamtmaße einer weichen Transporttasche (geschlossener Typ) dürfen 115 cm nicht überschreiten.',
			'Pro erwachsenem Passagier ist nur ein Tier erlaubt.',
			'Die Platzierung von Passagieren mit Tieren in den vorderen Reihen ist nicht gestattet.'
		],
		'Miles are not credited for this flight.': 'Für diesen Flug werden keine Meilen gutgeschrieben.',
		'Baggage delivery': 'Gepäckzustellung',
		'per place': 'pro Gepäckstück',
		'All passengers': 'Alle Passagiere',
		'Proceeding to payment...': 'Zahlungsvorgang wird eingeleitet...',
		'An order for this flight and the set of passengers already exists':
			'Eine Buchung für diesen Flug mit diesen Passagieren existiert bereits',
		'У разных элементов Traveller не может быть одинакового значение параметра LinkedTo, большего чем 0':
			'Ein Erwachsener kann nicht mehreren Kleinkindern ohne eigenen Sitzplatz zugewiesen werden. Bitte ordnen Sie jedem Kind einen eigenen Begleiter zu.',
		'You are not logged in': 'Sie sind nicht angemeldet',
		'Add protection': 'Schutz hinzufügen',
		'Remove protection': 'Schutz entfernen',
		'For all passengers': 'Für alle Passagiere',
		'Want to add extra protection while traveling?': 'Möchten Sie zusätzlichen Reiseschutz hinzufügen?',
		InsuranceGroupTitle_default: 'Versicherung',
		InsuranceGroupDescr_default: 'Kostenerstattung bei Flugverspätung oder -annullierung',
		InsuranceGroupTitle_common: 'Versicherung bei Flugänderung',
		InsuranceGroupDescr_common:
			'Erhalten Sie eine <strong>Entschädigung von bis zu 40.000 RUB</strong> im Falle einer Flugannullierung oder -änderung.',
		InsuranceGroupTitle_flight: 'Umfassende Flugversicherung',
		InsuranceGroupDescr_flight:
			'Erstattung bis zu 500.000 RUB bei Verspätung oder Annullierung, Gepäck- und Gesundheitsschutz während des Fluges.',
		InsuranceGroupTitle_med: 'Reise-Krankenversicherung',
		InsuranceGroupDescr_med:
			'Erforderlich für Reisen ins Ausland. Deckt ambulante und stationäre Behandlung, auch bei COVID-19, Zahnmedizin, medizinischen Rücktransport, Kinderbetreuung und Dokumentenersatz.',
		'fare rules': 'tarifregeln'
	},
	CheckoutAdditionalService: {
		Add: 'Hinzufügen',
		from: 'ab',
		Exclusive: 'Exklusiv'
	},
	CheckoutOrderSummary: {
		'Order must be paid': 'Bestellung muss bezahlt werden',
		before: 'bis',
		'today before': 'bis heute',
		'View details': 'Flugdetails anzeigen',
		'Order number': 'Bestellnummer'
	},
	Communications: {
		Communications: 'Kommunikation',
		Notifications: 'Benachrichtigungen',
		'My appeals': 'Meine Anfragen',
		Chat: 'Chat',
		Promotions: 'Marketing-Benachrichtigungen',
		'Order notifications': 'Bestellbenachrichtigungen',
		'My promo codes': 'Meine Promo-Codes',
		Back: 'Zurück',
		'Mark all as read': 'Alle als gelesen markieren',
		Updated: 'Aktualisiert',
		Created: 'Erstellt',
		Status: 'Status',
		'Call to action': 'Handlungsaufruf',
		Order: 'Bestellung',
		'Book with promo code': 'Mit Promo-Code buchen',
		Personal: 'Persönlich',
		Reusable: 'Wiederverwendbar',
		New: 'Neue',
		WaitingAnswer: 'Es wartet auf Antwort',
		InProgress: 'In Bearbeitung',
		Solved: 'es ist erledigt',
		Rejected: 'es ist abgelehnt',
		Used: 'es ist verwendet',
		Expired: 'es ist abgelaufen',
		'Can be used until': 'es ist gültig bis',
		ID: 'Persönlich ID',
		Oops: 'Ups...',
		'Something went wrong': 'Etwas ist schiefgelaufen',
		'Mark as read': 'Als gelesen markieren',
		'There is nothing yet': 'Noch nichts vorhanden',
		Empty_my_appeals: 'Sie haben noch keine Anfragen',
		Empty_promotions: 'Sie haben noch keine Marketing-Benachrichtigungen',
		Empty_order_notifications: 'Sie haben noch keine Bestellungen',
		Empty_my_promo_codes: 'Sie haben noch keine Promo-Codes'
	},
	CompareFares: {
		Label: 'Schaltfläche',
		'Internal error': 'Interner Fehler',
		'Compare fare families': 'Tarifklassen vergleichen',
		Economy: 'Economy-Klasse',
		Light: 'Licht-Klasse',
		Classic: 'Classic-Klasse',
		Flex: 'Flex',
		Business: 'Business-Klasse',
		Premium: 'Premium-Klasse',
		Baggage: 'Gepäck',
		'Checked baggage': 'Aufgegebenes Gepäck',
		Services: 'Services',
		'Ticket changes': 'Ticketänderungen',
		Cancellation: 'Stornierung',
		'In-Cabin service': 'Bordservice',
		'Comfort kit': 'Komfortset',
		'Airport sevices': 'Flughafenservices',
		'Priority boarding': 'Bevorzugtes Einsteigen',
		'Priority baggage delivery': 'Bevorzugte Gepäckausgabe',
		'Lounge service': 'Zugang zur Lounge',
		'View full fare conditions': 'Vollständige Tarifbedingungen anzeigen',
		Note: 'Hinweis',
		'Go back': 'Zurück gehen',
		'The fare difference is calculated taking into account the prices available through our global reservations system, not the airBaltic website':
			'Die Tarifdifferenz wird auf Grundlage der über unser globales Buchungssystem verfügbaren Preise berechnet und nicht auf Basis der Preise auf der airBaltic-Website.',
		'Please see detailed baggage rules that apply to airBaltic operated flights here':
			'Bitte beachten Sie die detaillierten Gepäckbestimmungen für von airBaltic durchgeführte Flüge hier.',
		'Passengers in possession of roundtrip tickets who have flown or are planning to fly one way only and wish to receive a refund for the unused part of the ticket, please make sure that the ticket type supports cancellation with refund. In such cases the value of the used portion of the ticket will be recalculated to reflect the price of a one-way ticket, and the remaining difference will be refunded after subtracting any cancellation fees, if applicable to the particular ticket type.':
			'Passagiere mit Hin- und Rückflugtickets, die nur eine Strecke genutzt haben oder nutzen möchten und eine Rückerstattung für den ungenutzten Teil wünschen, stellen Sie bitte sicher, dass der Tickettyp eine Stornierung mit Rückerstattung zulässt. In solchen Fällen wird der genutzte Ticketanteil zum Preis eines einfachen Fluges neu berechnet, und der verbleibende Betrag wird nach Abzug eventueller Stornogebühren erstattet, sofern diese für den jeweiligen Tickettyp gelten.',
		'Name and/or surname change or correction is only possible if the ticket issued is an airBaltic document and the booking consists of flights operated by airBaltic.':
			'Namens- und/oder Nachnamensänderungen oder -korrekturen sind nur möglich, wenn das ausgestellte Ticket ein airBaltic-Dokument ist und die Buchung ausschließlich airBaltic-Flüge enthält.',
		'Applicable for tickets booked after 18th of February 2018, for tickets booked before 19th of February, cancellation allowed anytime. A refund fee of 100 EUR applies to each ticket.':
			'Gilt für Tickets, die nach dem 18. Februar 2018 gebucht wurden. Für Tickets, die vor dem 19. Februar gebucht wurden, ist eine Stornierung jederzeit möglich. Es fällt eine Rückerstattungsgebühr von 100 EUR pro Ticket an.',
		'For tickets that are purchased until 31.05.2018, a transition period from 01.06.2018-30.06.2018 is applicable. During this period fee is EUR 50.':
			'Für Tickets, die bis zum 31.05.2018 gekauft wurden, gilt eine Übergangsfrist vom 01.06.2018 bis 30.06.2018. Während dieses Zeitraums beträgt die Gebühr 50 EUR.'
	},
	Consents: {
		agreement_gdsRules: 'mit den <a href=\'#\' target=\'_blank\'>Bedingungen</a> für Zusatzleistungen',
		agreement_insurancesRules:
			'den <a href=\'#\' target=\'_blank\'> Versicherungsbedingungen</a> sowie den Bedingungen von {{insurancesProductsLinks}}',
		agreement_generalRules: '<span><a href=\'#\' target=\'_blank\'>den Kaufbedingungen</a></span>',
		agreement_interpolation: '{{generalRules}}{{insurancesRules}}{{additionalServiceRules}}',
		agreement_rules:
			'Ich habe mich mit {{links}} vertraut gemacht, akzeptiere die Zahlung für diese Zusatzleistungen und stimme ihnen zu.',
		agreement_additionalInsuranceRules: 'den Bedingungen des öffentlichen Angebots {{link}}',
		agreement_additionalInsuranceName: '«{{name}}»'
	},
	Contacts: {
		'Your contacts': 'Ihre Kontaktdaten',
		'Contact details are necessary for us to be able to pass on the latest flight information.':
			'Kontaktdaten sind erforderlich, um Informationen zur Buchung zu erhalten.',
		Email: 'E-Mail',
		Phone: 'Telefon',
		'We sent SMS with verification code to the phone': 'Geben Sie den Bestätigungscode aus der SMS ein',
		'Didnt get the code? ': 'Code nicht erhalten?',
		'Resend it': 'Erneut senden',
		Edit: 'Bearbeiten',
		'Invalid code.': 'Ungültiger Code',
		'Want to speed up passenger data entry? Log in and continue.':
			'Melden Sie sich bitte an, um Ihre Daten zu speichern und sie beim nächsten Mal nicht erneut einzugeben.',
		'Want to speed up passenger data entry? Sign up and continue.':
			'Registrieren Sie sich bitte, um Ihre Daten zu speichern und sie beim nächsten Mal nicht erneut einzugeben',
		'Want to speed up passenger data entry?': 'Möchten Sie die Eingabe der Passagierdaten beschleunigen?',
		'Log in': 'Anmelden',
		'Sign up': 'Registrieren',
		Next: 'Weiter',
		'You can get the new code in': 'Neuer Code kann gesendet werden in...',
		'Sending message...': 'Sende Code...',
		'Code sent': 'es hat Code gesendet',
		'Welcome!': 'Willkommen',
		'Want to speed up passenger data entry? Sign in and continue.':
			'Möchten Sie den Buchungsvorgang beschleunigen? Melden Sie sich an.',
		'Continue without signing in': 'Ohne Anmeldung fortfahren',
		'Sign in': 'Anmelden',
		'Phone number of the same digits is not allowed': 'Bitte geben Sie eine gültige Telefonnummer ein',
		'Incorrect phone number': 'Falsche Telefonnummer. Bitte geben Sie eine gültige Telefonnummer ein',
		'Min 10 digits': 'Mindestens 10 Ziffern',
		'Max 18 digits': 'Maximal 18 Ziffern',
		'Example +1234567890': 'Beispiel: +123456789',
		'Incorrect email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
		Required: 'Pflichtfeld',
		'Receive a mailing list with promotional offers and discounts':
			'Ich möchte Werbeangebote und Rabatte per E-Mail erhalten',
		Back: 'Zurück'
	},
	CustomerContacts: {
		'Please, enter your contacts': 'Bitte geben Sie Ihre Kontaktdaten ein'
	},
	CustomerContactsForm: {
		'Please, enter your contacts': 'Bitte geben Sie Ihre Kontaktdaten ein',
		Done: 'Fertig',
		Email: 'E-Mail',
		Phone: 'Telefon',
		Required: 'Pflichtfeld',
		'Please enter a valid email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
		'Please enter a valid phone': 'Bitte geben Sie eine gültige Telefonnummer  ein',
		'Please enter a valid FFP': 'Bitte geben Sie eine gültige Vielfliegerkartennummer ein'
	},
	Datepicker: {
		month_0: 'Januar',
		month_1: 'Februar',
		month_2: 'März',
		month_3: 'April',
		month_4: 'Mai',
		month_5: 'ИюJuniнь',
		month_6: 'Juli',
		month_7: 'August',
		month_8: 'September',
		month_9: 'Oktober',
		month_10: 'November',
		month_11: 'Dezember',
		week_short_0: 'Mo',
		week_short_1: 'Di',
		week_short_2: 'Mi',
		week_short_3: 'Do',
		week_short_4: 'Fr',
		week_short_5: 'Sa',
		week_short_6: 'So'
	},
	DesktopFlight: {
		Select: 'Auswählen',
		'Select fare': 'Tarif auswählen',
		Arrival: 'Ankunft',
		stop: 'Zwischenstopp',
		stops: 'Zwischenstopps',
		Nonstop: 'Direktflug',
		Details: 'Details',
		'Need_f ': 'Benötigte',
		'Need_m ': 'Benötigter',
		'the ability to refund ticket': 'Möglichkeit zur Ticketrückerstattung',
		'the ability to exchange ticket': 'Möglichkeit zum Ticketumtausch',
		baggage: 'Gepäck',
		and: 'und'
	},
	DesktopFlightInfo: {
		Terminal: 'Terminal',
		Duration: 'Dauer',
		'Arrival the next day': 'Ankunft am nächsten Tag',
		'Eco-friendly': 'Umweltfreundlich',
		'Service is unavailable on this flight': 'Dienstleistung auf diesem Flug nicht verfügbar',
		TechnicalLandingIn_0: 'Technische Zwischenlandung in',
		TechnicalLandingIn_1: 'Technische Zwischenlandungen in',
		'Total duration': 'Gesamtdauer',
		'Stop in': 'Zwischenstopp in,',
		'Select from': 'Auswählen ab',
		Select: 'Auswählen',
		from: 'ab',
		Canceled: 'ist Storniert',
		'taxes and fees': 'Steuern und Gebühren',
		'Operating carrier': 'Durchführende Fluggesellschaft',
		SubStatus_AwaitingExchange: 'Im Austauschprozess',
		SubStatus_Upgrade: 'Der Serviceklassen-Upgrade wird durchgeführt'
	},
	DesktopSummaryFlight: {
		'Change flight': 'Anderen Flug wählen',
		'Fare rules': 'Tarifbestimmungen',
		'Baggage info': 'Gepäckinformationen',
		Details: 'Einzelheiten',
		Charter: 'Charterflug'
	},
	DocumentCardForm: {
		Document: 'Dokument',
		Country: 'Land',
		'Document type': 'Dokumenttyp',
		'Document number': 'Dokumentennummer',
		'Expiry date': 'Ablaufdatum',
		Save: 'SpeichernSpeichern',
		Required: 'Pflichtfeld',
		Remove: 'Entfernen'
	},
	Exchange: {
		'Change ticket': 'Ticket ändern',
		'Successful payment': 'Zahlung erfolgreich',
		'Failed payment': 'Zahlung fehlgeschlagen',
		'Add new request': 'Neue Anfrage erstellen',
		'Select passengers': 'Auswählen Sie bitte Passagiere ',
		Back: 'Zurück',
		Next: 'Weiter',
		'Select flights': 'Auswählen Sie bitte Flüge ',
		'Select new flight': 'Auswählen Sie bitte neuen Flug ',
		'Open calendar': 'Datum wählen',
		'You’ve chosen': 'Ihre Auswahl',
		Clear: 'Löschen',
		Search: 'Suche',
		'Change flight': 'Flug ändern',
		Note: 'Beachten Sie bitte (Hinweis)',
		'Exchange restrictions': 'Austauschbeschränkungen',
		'The possibility and cost of changes will be calculated by the operator after sending the application. The answer will be sent to your E-mail and is also available on the order page.':
			'Die Möglichkeit und die Kosten der Änderungen werden vom Betreiber nach dem Absenden der Anfrage berechnet. Die Antwort wird an Ihre E-Mail gesendet und ist auch auf der Bestellseite verfügbar.',
		'After submitting the request, the seats you have selected will be canceled.':
			'Nach dem Absenden der Anfrage werden die von Ihnen gewählten Sitzplätze storniert.',
		'Create request': 'Anfrage erstellen',
		Contacts: 'Kontakte Anfrage erstellen',
		'Your name': 'Ihr Name',
		Email: 'E-Mail',
		'I agree with the': 'Ich stimme den',
		'Terms of Service': 'Nutzungsbedingungen',
		And: 'und',
		'Privacy Policy': 'Datenschutzbestimmungen',
		'Your phone': 'Ihre Telefonnummer',
		'Your comment': 'Ihr Kommentar',
		'I agree to the Terms of Service and Privacy Policy':
			'Ich stimme den Nutzungsbedingungen und der Datenschutzrichtlinie zu',
		Request: 'Anfrage',
		Create: 'ist erstellen',
		'Your comments': 'Ihr Kommentar ',
		'The cost of changes will be calculated by the operator after choosing the option and sending the request to the operator.':
			'Die Änderungskosten werden vom Betreiber nach Auswahl der Option und Absenden der Anfrage berechnet.',
		'Local time indicated': 'Ortszeit angegeben',
		'Order must be paid by {{time}} on {{date}}': 'Die Bestellung muss bis {{date}} um {{time}} bezahlt werden',
		InProcess: 'In Bearbeitung',
		NeedConfirm: 'Wartet auf Bestätigung',
		AwaitingPayment: 'Wartet auf Zahlung',
		Finished: 'Abgeschlossen',
		Rejected: 'Abgelehnt',
		Refused: 'Zurückgezogen',
		TimelimitExpired: 'Zahlungsfrist abgelaufen',
		'If you change your mind, or want to create a new request with different parameters, delete this request':
			'Wenn Sie Ihre Meinung ändern oder eine neue Anfrage mit anderen Parametern erstellen möchten, löschen Sie diese Anfrage',
		'Delete request': 'Anfrage löschen',
		'The change request was deleted. Want to create a new request?':
			'Die Änderungsanfrage wurde gelöscht. Möchten Sie eine neue Anfrage erstellen?',
		Yes: 'Ja',
		No: 'Nein',
		'Limited exchange time': 'Begrenzte Änderungszeit',
		'Offer valid until {{date}}': 'Angebot gültig bis {{date}}',
		'Exchange penalty': 'Strafe und Gebühren für Änderungen',
		Total: 'Gesamt',
		Required: 'Pflichtfeld',
		'Please, read the rules of service and accept it': 'Bitte lesen und akzeptieren Sie die Nutzungsbedingungen',
		'Please enter a valid email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
		'Please enter a valid phone': 'Bitte geben Sie eine gültige Telefonnummer ein',
		'Whole flight': 'Gesamter Flug',
		'We couldn\'t find any flights for given dates': 'Für die angegebenen Daten wurden keine Flüge gefunden',
		'Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.':
			'Bitte wählen Sie ein anderes Datum oder ändern Sie Ihre Suche. Wenn Sie ein Ticket für dieses bestimmte Datum kaufen möchten, wenden Sie sich bitte an den Kundenservice.',
		for: 'für',
		'Successfully create new booking': 'Neue Buchung erfolgreich erstellt',
		'View new booking': 'Neue Buchung anzeigen',
		'Request for changes': 'Änderungsanfrage',
		'Payment exchange': 'Bezahlen',
		'Oops...': 'Ups...',
		'{{segmentId}}. {{depDate}}, {{airlineCode}}{{flightNumber}}. {{depIata}}({{depTime}}) -> {{arrIata}}({{arrTime}}). Тариф {{tariff}}':
			'{{segmentId}}. {{depDate}}, {{airlineCode}}{{flightNumber}}. {{depIata}}({{depTime}}) -> {{arrIata}}({{arrTime}}). Tarif: {{tariff}}',
		Refund: 'Zurückerstattung',
		'All services issued on one electronic document will be canceled, even if you change itinerary partial. Money refund will be carried out by the airline in accordance with the terms of the Puplic Offer':
			'Alle Dienstleistungen, die in einem elektronischen Dokument ausgestellt wurden, werden storniert, auch wenn Sie nur einen Teil der Reiseroute ändern. Die Rückerstattung erfolgt durch die Fluggesellschaft gemäß den Bedingungen des öffentlichen Angebots.',
		'Select type of change': 'Art der Änderung auswählen',
		'Voluntary change': 'Freiwillige Änderung',
		'Involuntary change': 'Unfreiwillige Änderung',
		Voluntary: 'Freiwillig',
		Involuntary: 'Unfreiwillig',
		'Back to order': 'Zurück zur Bestellung',
		'terms of tariff': 'Tarifbedingungen',
		'Select date for flight {{direction}}': 'Datum für Flug {{direction}} auswählen',
		'If you wish to exchange your ticket, please cancel your flight check-in.':
			'Wenn Sie Ihr Ticket umtauschen möchten, stornieren Sie bitte zuerst den Check-in.',
		'You can do it yourself by going to <a href=\'{{checkInURL}}\' target=\'_blank\'>Online check-in</a>.':
			'Sie können dies selbst tun, indem Sie zur <a href=\'{{checkInURL}}\' target=\'_blank\'> Online-Registrierung </a>.',
		'Either select unused ticket segments for exchange.':
			'Wählen Sie nicht genutzte Ticketsegmente für den Austausch aus.',
		'It is not possible to exchange the ticket on which the check-in was made for the flight':
			'Ein Ticket, für das bereits eingecheckt wurde, kann nicht umgetauscht werden',
		'It is not possible to exchange a used ticket': 'Ein benutztes Ticket kann nicht umgetauscht werden',
		'The ticket has been flown on, you cannot exchange the used ticket':
			'Das Ticket wurde bereits verwendet – ein Umtausch ist nicht möglich',
		'Partially used ticket can be exchanged only in manual mode':
			'Ein teilweise genutztes Ticket kann nur manuell umgetauscht werden',
		'Contact the airline call-center to clarify the conditions of the exchange, as a part of the route was flown. Or select segments of an unused ticket for exchange.':
			'Wenden Sie sich an das Callcenter der Fluggesellschaft, um die Umtauschbedingungen zu klären, da ein Teil der Route bereits geflogen wurde. Oder wählen Sie nicht genutzte Segmente für den Umtausch aus.',
		'Part of the route was flown, part of the ticket is used. The application for exchange will be considered manually by the airline':
			'Ein Teil der Route wurde geflogen, ein Teil des Tickets wurde genutzt. Der Antrag auf Umtausch wird manuell von der Fluggesellschaft geprüft.',
		'Select new date': 'Neues Datum auswählen',
		'Select date': 'Datum auswählen'
	},
	FareConditions: {
		'Try again': 'Erneut versuchen',
		'Internal error': 'Interner Fehler',
		Sheremetyevo: 'Sheremetjewo',
		Riga: 'Riga',
		Original: 'Original',
		'Translate to russian*': 'Ins Russische übersetzen',
		'Fare conditions': 'Tarifbedingungen',
		'from 12 years': 'ab 12 Jahren',
		'from 2 to 12 years': 'von 2 bis 12 Jahren',
		'without seat': 'ohne Sitzplatz',
		'Fare code': 'Tarifcode',
		'See more details on this page': 'Weitere Details auf dieser Seite'
	},
	FareGroup: {
		Select: 'Auswählen',
		Unavailable: 'Nicht verfügbar ',
		Recommended: 'Bestseller',
		'Compare fare families': 'Tarifoptionen vergleichen',
		Choose: 'Wählen',
		Rules: 'Regeln',
		Taxes: 'Gebühren',
		'Not enough miles on your card': 'Nicht genügend Meilen auf Ihrer Karte'
	},
	FareLock: {
		'Fixation the cost of the air ticket': 'Fixierung des Flugpreises',
		'Check your selection and pay fare lock': 'Überprüfen Sie Ihre Auswahl und bezahlen Sie die Tarif-Fixierung',
		'If you make the decision to fly on the selected date within the next {{hours}} {{plural}}, you will be able to pay the full amount of the booking at the fare you locked in. Please, be advised that Fare lock fee is non-refundable.':
			'Wenn Sie sich innerhalb der nächsten {{hours}} {{plural}} entscheiden, am gewählten Datum zu fliegen, können Sie den vollen Buchungsbetrag zum festgelegten Tarif bezahlen. Bitte beachten Sie, dass die Gebühr für die Tarif-Fixierung nicht erstattungsfähig ist.',
		'No need to worry about the price increase or about the fact that all tickets will be sold out, now you can fix the ticket price for {{hours}} {{plural}}':
			'Sie müssen sich keine Sorgen über einen Preisanstieg oder ausverkaufte Tickets machen – jetzt können Sie den Ticketpreis für {{hours}} {{plural}} fixieren.',
		hours_0: 'Stunde',
		hours_1: 'Stunden',
		hours_2: 'Stunden',
		'Lock fare': 'Tarif fixieren',
		only: 'Insgesamt',
		'Confirmed fare lock': 'Tarif-Fixierung bestätigt'
	},
	FlightCard: {
		Flight: 'Flug',
		Duration: 'Dauer',
		'The flight operates': 'Der Flug wird durchgeführt von'
	},
	FlightInfo: {
		Details: 'Flugdetails'
	},
	FlightInfoModalContent: {
		'You choose': 'Sie haben gewählt',
		'Compare fares': 'Tarife vergleichen',
		'Fare rules': 'Tarifregeln',
		'Select your bundle': 'Wählen Sie Ihr Tarifpaket',
		Economy: 'Economy',
		Business: 'Business',
		Premium: 'Premium',
		'Flight info': 'Fluginformationen',
		'More details': 'Weitere Details',
		'comfortable salon': 'Komfortabler Salon',
		'access to wifi': 'WIFI-Zugang (WLAN-Zugang)',
		'View full conditions': 'Vollständige Tarifbedingungen anzeigen',
		'hot and children\'s menu': 'Warm- und Kindermenü',
		'comfortable seating': 'Bequeme Sitzplätze',
		'access to airport lounge': 'Zugang zur Flughafenlounge',
		'meals are included in the price': 'Mahlzeiten im Preis inbegriffen',
		'premium fare': 'Premiumtarif',
		'Back to flights': 'Zurück zu den Flügen',
		'Total duration': 'Gesamtdauer',
		'Scroll up': 'Nach oben scrollen',
		Selected: 'Ausgewählt',
		'SelectedFareGroup_View full conditions': 'Vollständige Tarifbedingungen anzeigen',
		Back: 'Zurück'
	},
	FlightPrice: {
		from: 'ab',
		'NO SEATS': 'KEINE PLÄTZE',
		Economy: 'Economy',
		Light: 'Light',
		Classic: 'Classic',
		Flex: 'Flex',
		Business: 'Business',
		Premium: 'Premium',
		'Select from': 'Auswählen ab',
		Select: 'Auswählen',
		'taxes and fees': 'Steuern und Gebühren',
		'Subsidized flight': 'Subventionierter Flug',
		'A subsidized fare requires all passengers on the booking to have benefits.':
			'Ein subventionierter Tarif ist nur möglich, wenn alle Passagiere der Buchung Anspruch auf Vergünstigungen haben.',
		left: 'verbleiben',
		left_0: 'es ist verbleibt',
		tickets: 'Ticket',
		tickets_1: 'Tickets',
		tickets_2: 'Tickets',
		'{{count}} {{ticket}} {{left}}': '{{left}} {{count}} {{ticket}}',
		'Special conditions for flight delays and ticket refunds':
			'Sonderbedingungen bei Flugverspätungen und Ticketrückerstattungen',
		'Full conditions': 'Vollständige Bedingungen',
		'Transit tariff': 'Transit-Tarif'
	},
	FlightsListControls: {
		Filter: 'Filter',
		Nonstop: 'Direktflug',
		'Flight Num': 'Flugnummer',
		'Enter airline code or flight number': 'Geben Sie bitte den Airline-Code oder die Flugnummer ein',
		Schedule: 'Flugplan'
	},
	FlightSortFilter: {
		Sort: 'Sortieren',
		'Price Graph': 'Preisdiagramm'
	},
	Forms: {
		Search: 'Suche',
		'My booking': 'Zugang zur Buchung',
		Checkin: 'Online-Check-in',
		'Ticket number': 'Ticketnummer',
		'Order number': 'Buchungs- oder Ticketnummer',
		'Last name': 'Nachname des Passagiers',
		Find: 'Suchen',
		Continue: 'Gehen Weiter',
		'To check in for a Smartavia flight, please visit their official website':
			'Um für einen Smartavia-Flug einzuchecken, besuchen Sie bitte die offizielle Website'
	},
	FullscreenDialog: {
		Close: 'Schließen'
	},
	GuardedApolloProvider: {
		'Ops...': 'Ups...',
		'Unfortunately, something went wrong. Please try again or contact with us':
			'Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.',
		Close: 'Schließen.',
		'The service is temporarily unavailable. It is possible that the order is open on another device/browser or being handled by an airline specialist. Please try again later.':
			'Der Service ist vorübergehend nicht verfügbar. Möglicherweise ist die Buchung auf einem anderen Gerät/Browser geöffnet oder wird von einem Airline-Mitarbeiter bearbeitet. Bitte versuchen Sie es später erneut.'
	},
	IncludedBaggage: {
		Included: 'Inklusive',
		there: 'Hinflug',
		return: 'Rückflug',
		'round trip': 'Hin- und Rückflug',
		Upgrade: 'Upgrade',
		included: 'inklusive',
		'Whole route': 'Gesamte Flugsstrecke',
		'Choose for each flight': 'Für jeden Flug auswähle',
		'Price per flight': 'Preis pro Flug',
		'Price for all flights': 'Preis für alle Flüge',
		Cancel: 'Abbrechen',
		Confirm: 'Bestätigen',
		Total: 'Gesamt',
		Clear: 'Löschen',
		'Added for all flights': 'Für alle Flüge hinzugefügt',
		Equipment: 'Ausrüstung',
		'Need to bring sports, music or baby equipments?':
			'Müssen Sie Sport-, Musikgeräte oder einen Kinderwagen mitnehmen?',
		'All flights': 'Alle Flüge',
		from: 'ab',
		total: 'gesamt',
		Edit: 'Bearbeiten',
		Add: 'Hinzufügen',
		'Up to': 'Bis zu'
	},
	IncludedOptions: {
		Included: 'Inklusive',
		'Baggage rules': 'Regeln Gepäckbestimmungen',
		'Upgrade cabin baggage': 'Handgepäck erweitern',
		'Get {{upgradedCabinBaggage}} of cabin baggage onboard, instead of {{includedCabinBaggage}}':
			'{{upgradedCabinBaggage}} Handgepäck an Bord statt {{includedCabinBaggage}}',
		pc: 'Stück',
		kg: 'kg',
		with: 'Tarif',
		Change: 'Ändern',
		Upgrade: 'Hinzufügen'
	},
	InfoCard: {
		document: 'Dokument',
		'Frequent Flyer programm': 'Vielfliegerprogrammkarte',
		passport: 'Reisepass',
		'International passport': 'Reisepass (international)',
		Number: 'Nummer',
		'Expiry date': 'Ablaufdatum',
		Delete: 'Löschen',
		Edit: 'Bearbeiten',
		Add: 'Hinzufügen',
		'dd.mm.yyyy': 'TT.MM.JJJJ'
	},
	InsurancePage: {
		'You lose protection and peace of mind in unforeseen situations.': 'Keine Versicherung ausgewählt',
		'Buy insurance': 'Versicherung abschließen',
		'I assume all risks and Cancel insurance': 'Ich verzichte auf Versicherungsschutz',
		'Insure your flight': 'es ist erforderlich Versicherung zu auswählen ',
		'To make your travels memorable only with pleasant excitement, take out an insurance policy that will protect you during your trip.':
			'Damit Ihre Reisen nur in angenehmer Erinnerung bleiben, schließen Sie eine Versicherung ab, die Sie während der Reise schützt.',
		'For all passengers': 'Für alle Passagiere',
		Remove: 'Entfernen',
		from: 'von',
		'I want protect my trip.': 'Ich möchte im Schadensfall eine Entschädigung erhalten',
		'I do not want to insure my life or luggage and assume all risks':
			'Ich reise ohne Versicherung und trage alle Kosten im Falle unvorhergesehener Ereignisse selbst',
		'More details': 'Mehr Details',
		'Choice of insurance': 'Versicherungswahl(Versicherung Typ)',
		'Back to services': 'Zurück zu den Services',
		Cancel: 'Abbrechen',
		Confirm: 'Bestätigen',
		InsuranceUpsaleMainDescription:
			'Sie erhalten keine Entschädigung bei Gepäckproblemen, Flugverspätungen oder -ausfällen sowie bei zusätzlichen medizinischen Kosten oder Unfällen.',
		InsuranceUpsaleAdditionalDescription:
			'Eine Reiseversicherung kostet im Durchschnitt nur 0,1 % der potenziellen Ausgaben im Schadensfall. Erfahrene Reisende schließen immer eine Versicherung ab, um sich auf den Zweck der Reise zu konzentrieren und unnötige Kosten zu vermeiden.',
		'Most popular': 'Beliebt bei Reisenden',
		'Download police': 'Police herunterladen',
		Add: 'Hinzufügen'
	},
	Loader: {
		loading: 'es wird geladen'
	},
	Location: {
		Terminal: 'Terminal',
		Details: 'Einzelheiten'
	},
	LocationAutocomplete: {
		'Recent searches': 'Sie haben gesucht ',
		'show all directions': 'Anschauen alles ',
		'Sorry, we do not fly': 'alle Richtungen anzeigen ',
		from: 'von',
		to: 'nach',
		'Nearby airports': 'Flughäfen in der Nähe',
		'Popular airports': 'Beliebte Reiseziele',
		'Perhaps you are looking for': 'Suchen Sie vielleicht',
		Stop_0: 'Zwischenstopps',
		Stop_1: 'Zwischenstopps',
		Stop_2: 'Zwischenstopps',
		From: 'Von',
		To: 'Nach ',
		'Enter city or country': 'Eingeben Sie bitte Stadt oder Land ',
		'Pick a country': 'Auswählen Sie bitte ein Land ',
		'Pick a city': 'Auswählen Sie bitte eine Stadt '
	},
	LoginPage: {
		'Log in': 'Anmelden',
		Required: 'Pflichtfeld',
		'Please enter a valid Email / Phone / Card number':
			'Bitte geben Sie eine gültige E-Mail / Telefonnummer / Kartennummer ein',
		'Email / Phone / Card number': 'E-Mail / Telefonnummer / Kartennummer',
		'or with you social network': 'anmelden Sie oder über soziales Netzwerk',
		'Please, read the rules of service and accept it':
			'Bitte lesen Sie die Nutzungsbedingungen und stimmen Sie der Verarbeitung personenbezogener Daten zu',
		'Welcome!': 'Willkommen',
		'You are logged in for the first time, please read the terms and conditions and give consent':
			'Sie haben sich zum ersten Mal angemeldet, bitte lesen Sie die Bedingungen und stimmen Sie der Datenverarbeitung zu',
		'I agree to the': 'Ich stimme der',
		'Terms of Service and Privacy Policy': 'Verarbeitung meiner personenbezogenen Daten zu',
		'An e-mail with code has been sent to you.': 'Ein E-Mail mit dem Code wurde an Sie gesendet.',
		'Code sent to your phone.': 'Der Code wurde an Ihr Telefon gesendet.',
		'Please, check the code': 'Bitte überprüfen Sie den eingegebenen Code',
		'Didn\'t get the code?': 'Code nicht erhalten?',
		'Resend it': 'Code erneut senden',
		'Welcome back,': 'Willkommen zurück,',
		'Welcome back!': 'Willkommen zurück!',
		'Enter code': 'Eingeben Sie bitte Bestätigungscode ',
		'Verification code': 'Bestätigungscode',
		Continue: 'Weiter',
		'Enter code_FFP': 'Passwort eingeben',
		'Verification code_FFP': 'Passwort ',
		Continue_FFP: 'Einloggen',
		'Enter code_Email': 'Eingeben Sie bitte Bestätigungscode ',
		'Verification code_Email': 'Bestätigungscode',
		Continue_Email: 'Weiter',
		'Enter code_Phone': 'Eingeben Sie bitte Bestätigungscode ',
		'Verification code_Phone': 'Bestätigungscode',
		Continue_Phone: 'Weiter',
		'If you don\'t have an account, it will be created automatically':
			'Wenn Sie kein Konto haben, wird es automatisch erstell',
		'Remember me': 'Angemeldet bleiben'
	},
	Loyalty: {
		'Log in to LightJet Club': 'Anmeldung im Websky Club',
		'Forgot password?': 'Passwort vergessen?',
		Step: 'Schritt',
		'Enter your email': 'Geben Sie bitte Ihre E-Mail-Adresse ein',
		Back: 'Zurück',
		Continue: 'Weiter',
		'Profile not found. Check spelling your e-mail address':
			'Profil nicht gefunden. Bitte überprüfen Sie die E-Mail-Adresse',
		'Enter code': 'Eingeben Sie bitte Code',
		'The verification code has been sent to the email': 'Der Bestätigungscode wurde an Ihre E-Mail gesendet',
		'Verification code': 'Bestätigungscode',
		'You entered an incorrect code': 'Falscher Code eingegeben',
		'Password reset': 'Passwort zurückgesetzt',
		'A new password has been sent to your e-mail': 'Ein neues Passwort wurde an Ihre E-Mail gesendet',
		'Back to login': 'Anmelden (Zurück zur Anmeldung)',
		Required: 'Pflichtfeld',
		'Card number': 'Kartennummer',
		Password: 'Passwort ',
		'Not a member yet? Join for free!': 'Noch kein Mitglied? Jetzt kostenlos beitreten!',
		'Create account': 'Konto erstellen',
		'I have a card': 'Ich habe bereits eine Karte',
		Create: 'Erstellen',
		'Data was sent to your email': 'Die Daten wurden an Ihre E-Mail gesendet',
		'You successfully created account. Check your email to sign in':
			'Sie haben erfolgreich ein Konto im Treueprogramm erstellt. Die Zugangsdaten wurden an Ihre E-Mail gesendet.',
		'Log in to account': 'Im Konto anmelden',
		'Your status': 'Ihr Status',
		'Ops...': 'Ups...',
		'Connect to loyalty program with your card': 'Verbinden Sie bitte Ihr Profil mit dem Treueprogramm',
		'Incorrect card number or password': 'Falsche Kartennummer oder Passwort',
		'Please enter your card number': 'Pflichtfeld',
		'Enter password': 'Pflichtfeld',
		red: 'Rot',
		silver: 'Platin',
		gold: 'Gold',
		platinum: 'Passwort ',
		miles: 'Meilen',
		'miles left for': 'Meilen bis zu',
		'Left for gold status': 'Fehlen bis Gold-Status',
		'Left for silver status': 'Fehlen bis Silben-Status',
		'Left for platinum status': 'Fehlen bis Platin-Status',
		About: 'Mehr erfahren',
		'Miles recovery': 'Flüge nachtragen',
		'Use miles': 'Meilen einlösen',
		Promotions: 'Aktionen',
		'Promo-code': 'Aktionscodes',
		'E-voucher': 'Gutschein',
		expiry: 'esläuft ab',
		expired: 'es ist abgelaufen',
		Connect: 'Verbinden',
		'Get promo code': 'Aktionscode erhalten',
		Get: 'Erhalten',
		Conditions: 'Bedingungen',
		'How to get': 'Wie erhalten',
		'How to use': 'Wie verwenden',
		Active: 'Aktiv',
		Expired: 'Abgelaufen',
		Total: 'Gesamt',
		'Exit and add another card': 'Zurück und andere Karte hinzufügen',
		'You sure?': 'Sind Sie sicher?',
		'Delete card from your account?': 'Karte aus Ihrem Konto entfernen?',
		No: 'Nein',
		Yes: 'Ja',
		or: 'oder',
		flights: 'Flüge',
		'Cannot create an account': 'Fehler beim Erstellen des Kontos',
		'Registration of persons under the age of 14 in the loyalty program is prohibited':
			'Die Registrierung im Treueprogramm ist erst ab 14 Jahren möglich',
		Close: 'Schließen',
		'out of': 'von',
		'Left {{miles}} for {{level}} status': 'Noch {{miles}} bis zum {{level}}-Status',
		'Start saving now': 'Jetzt sparen!\nSammeln Sie Meilen und lösen Sie sie bei zukünftigen Flügen ein.',
		Registration: 'Registrierung',
		Statuses: 'Statuslevel',
		Earn: 'Sammeln',
		'Earn miles': 'Meilen sammeln',
		Status: 'Status',
		Use: 'Einlösen',
		FAQ: 'Häufige Fragen',
		'Please wait, we are updating information about your loyalty card. It make take a  few minutes...':
			'Bitte warten Sie, wir aktualisieren Ihre Treuekartendaten. Dies kann einige Minuten dauern...',
		'To continue registering in the loyalty system, fill out and confirm your email in your personal account.':
			'Um die Registrierung im Treuesystem fortzusetzen, geben Sie Ihre E-Mail an und bestätigen Sie diese im persönlichen Bereich. ',
		'Fill email': 'E-Mail eingeben',
		'This auth type is already being used in another account':
			'Dieser Kartentyp wird bereits in einem anderen Konto verwendet',
		'The use of a loyalty card is prohibited': 'Die Verwendung dieser Karte ist nicht erlaubt'
	},
	LoyaltyBonus: {
		'LightJet Club': 'Websky Club',
		miles: 'Meilen',
		'You will get for this flight': 'Für diesen Flug erhalten Sie ...',
		'Fly with us and get bonuses!': 'Fliegen Sie mit uns und sammeln Sie Prämien!'
	},
	LoyaltyCardForm: {
		'Frequent Flyer': 'Vielfliegerkarte',
		'Frequent Flyer Programm': 'Vielfliegerprogramme',
		'Document number': 'Nummer',
		Save: 'Speichern',
		Required: 'Pflichtfeld'
	},
	Meal: {
		Add: 'Hinzufügen',
		Select: 'Auswählen',
		Clear: 'Löschen',
		Done: 'Fertig',
		g: 'Gramm',
		Allergens: 'Allergene',
		Free: 'Kostenlos',
		'Show description': 'Details anzeigen',
		Total: 'Gesamt',
		'Add for all': 'Für alle hinzufügen'
	},
	MealPage: {
		'Meals on board': 'Mahlzeiten an Bord',
		'Feel the taste in flight': 'Genießen Sie den Geschmack während des Flugs\n\n\n',
		Meal: 'Mahlzeit'
	},
	MealService: {
		All: 'Alle Gerichte',
		'Select menu': 'Auswählen Sie bitte Menü',
		serving_0: '{{count}} Portion',
		serving_1: '{{count}} Portionen',
		serving_2: '{{count}} Portionen',
		select: 'auswählen',
		'Terms & conditions': 'Bedingungen für die Verpflegung',
		Unavailable: 'Nicht verfügbar',
		'Selected dishes': 'Ausgewählte Gerichte'
	},
	MetasearchLoader: {
		'Checking seats availability': 'Sitzplatzverfügbarkeit wird geprüft',
		'Just a few seconds...': 'Das dauert nur ein paar Sekunden...',
		'Booking service is temporary unavailable': 'Der Buchungsservice ist vorübergehend nicht verfügbar',
		'Please reload the page': 'Bitte laden Sie die Seite neu',
		Reload: 'Neu laden'
	},
	MilesRecovery: {
		'Miles recovery': 'Meilenrückerstattung',
		'Please note that miles recovery is possible':
			'Bitte beachten Sie, dass eine Meilenrückerstattung möglich ist:',
		MoreThanSixMonthsFlights: 'nur für bereits durchgeführte Flüge',
		OnlyCompletedFlights: 'für Flüge, die nicht länger als 6 Monate zurückliegen',
		'Ticket number': 'Ticketnummer',
		Create: 'Antrag erstellen',
		'Passenger surname': 'Nachname des Passagiers',
		Required: 'Pflichtfeld',
		'Order not found': 'Buchung nicht gefunden',
		'Enter your ticket number': 'Geben Sie Ihre Ticketnummer ein',
		'Invalid date': 'Ungültiges Datum angeben',
		'Flight date': 'Flugdatum',
		'Flight number': 'Flugnummer',
		'Pick a flight date': 'Wählen Sie ein Flugdatum'
	},
	MobileAuthForm: {
		'Sign in': 'Anmelden Sie bitte',
		'and fill in passengers info with a single click': 'und füllen Sie Passagierdaten mit einem Klick aus',
		'Sign in with email': 'Mit E-Mail anmelden',
		'Continue as a guest': 'Als Gast fortfahren'
	},
	MobileSegmentInfo: {
		Nonstop: 'Direkt',
		'More info': 'Mehr Information',
		stop: 'Umstieg',
		in: 'in',
		Terminal: 'Terminal'
	},
	MobileSelectedFare: {
		'You selected': 'Sie haben ausgewählt',
		'Compare fare families': 'Tarifklassen vergleichen',
		'Fare conditions': 'Tarifbedingungen',
		Free: 'Kostenlos',
		'Fare rules': 'Tarifregeln',
		'Baggage info': 'Gepäckinformationen'
	},
	MobileStepbar: {
		Flights: 'Flug',
		Passengers: 'Passagiere',
		'Onboard Services': 'Borddienste',
		Extras: 'Zusatzleistungen',
		Payment: 'Zahlung',
		Add: 'Hinzufügen',
		Total: 'Gesamt',
		Economy: 'Economyklasse',
		Business: 'Businessklasse',
		Adult: 'Erwachsener',
		Child: 'Kind',
		Infant: 'Kleinkind',
		'Infant with seat': 'Kleinkind mit Sitzplatz',
		Details: 'Details',
		Change: 'Ändern',
		ADT: 'Erwachsener',
		CLD: 'Kind',
		INF: 'Kleinkind',
		INS: 'Kleinkind mit Sitzplatz',
		M: 'Mann',
		F: 'Frau',
		Contact: 'Kontakt',
		'Not selected': 'Nicht ausgewählt',
		Free: 'Kostenloss'
	},
	MobileSummaryFlight: {
		Returning: 'Zurück',
		Departing: 'Hin',
		'taxes and fees': 'Gebühren'
	},
	MobileToolbar: {
		Back: 'Zurück',
		Continue: 'Weiter'
	},
	ModalConfirm: {
		Cancel: 'Abbrechen',
		Confirm: 'Bestätigen'
	},
	OrderCard: {
		'Booking ID': 'Buchungscode',
		Open: 'Öffnen',
		'Security code': 'Sicherheitscode',
		Passengers: 'Passagiere',
		Details: 'Details',
		Transactions: 'Transaktionen',
		Download: 'Herunterladen',
		Confirmed: 'Bezahlt',
		'The order must be paid today': 'Die Bestellung muss heute bezahlt werden bis',
		'The order must be paid at': 'Die Bestellung muss bezahlt werden bis',
		'Online check-in started': 'Online-Check-in geöffnet',
		'Tickets have been sent to {{email}}': 'Tickets wurden an {{email}} gesendet',
		'Send tickets to the email?': 'Tickets an die E-Mail senden?',
		Booked: 'Gebucht',
		Cancelled: 'Storniert',
		Total: 'Gesamt',
		'Changed your plans?': 'Pläne geändert?',
		Exchange: 'Umtauschen',
		Refund: 'Rückerstattung',
		'Review:Waiting for payment': 'Warten auf Zahlung',
		'Review:Expires at': 'Läuft ab',
		'Review:Expires today at': 'Läuft heute ab um',
		'Account:Waiting for payment': 'Warten auf Zahlung',
		'Account:expires at': 'Läuft ab',
		'Account:expires today at': 'Läuft heute ab um',
		'Check-in': 'Online-Check-in',
		'Resend it': 'Erneut senden',
		'Passengers details': 'Passagierinformationen',
		'Expired date': 'Ablaufdatum',
		Gender_male: 'Männlich',
		Gender_female: 'Weiblich',
		'Additional information': 'Zusätzliche Informationen',
		Accompanying: 'Begleitperson',
		accompanies: 'begleitet',
		'Select an adult for accompany': 'Wählen Sie einen erwachsenen Begleiter',
		'After selecting a new adult, please double-check all services. Please choose an adult who does not sit on the emergency seat row.':
			'Nach Auswahl eines neuen Erwachsenen überprüfen Sie bitte alle Dienstleistungen erneut. Bitte wählen Sie einen Erwachsenen, der nicht in der Notausgangsreihe sitzt.',
		Confirm: 'Bestätigen',
		'Change link to adult': 'Verbindung zum Erwachsenen ändern',
		'Oops...': 'Ups...',
		'An error occurred while executing the request. Please try again later or contact a customer support service.':
			'Beim Ausführen der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Kundendienst.',
		OK: 'OK',
		DeleteFromList: 'Aus Liste entfernen',
		BookingRemoval: 'Buchung löschen',
		BookingRemovalMessage: 'Die Buchung {{orderLocator}} wird aus der Liste entfernt',
		Remove: 'Entfernen',
		Cancel: 'Abbrechen'
	},
	OrderChangeHistoryModal: {
		History: 'Verlauf',
		'Loading...': 'Lädt...',
		'History is empty': 'Verlauf ist leer',
		Time: 'Datum/Zeit',
		Action: 'Aktion'
	},
	OrderSummary: {
		Booking: 'Buchungscode',
		'Security code': 'Zugangscode',
		from: 'von',
		to: 'nach',
		Manage: 'Ansehen',
		'Currently there are no active bookings made through your private profile.':
			'Sie haben noch keine Buchungen vorgenommen.',
		'Search flight': 'Flugsuche',
		'I have a booking': 'Buchung hinzufügen',
		'Check-in': 'Online-Check-in',
		Download: 'Herunterladen',
		'For accessing booking page from another device': 'Um von einem anderen Gerät auf die Buchung zuzugreifen',
		'Waiting for payment': 'Zahlung ausstehend',
		'expires at': 'läuft ab um',
		'expires today at': 'läuft heute ab um',
		'Time to complete booking has expired': 'Zeit zur Buchung ist abgelaufen'
	},
	Page404: {
		'Destination unknown': 'Dieses Ziel fliegen wir nicht an',
		'PAGE NOT FOUND': 'SEITE NICHT GEFUNDEN',
		'Take me home': 'Zur Startseite zurückkehren'
	},
	Passenger: {
		Adult: 'Erwachsener',
		Child: 'Kind',
		Infant: 'Säugling',
		'Infant with seat': 'Säugling mit Sitzplatz',
		phone: 'Telefon',
		email: 'E-Mail',
		latinFirstName: 'Vorname (lateinisch)',
		latinLastName: 'Nachname (lateinisch)',
		latinMiddleName: 'Zweiter Vorname (lateinisch)',
		docIssued: 'Ausstellungsdatum des Dokuments',
		docIssuedBy: 'Code der ausstellenden Organisation',
		city: 'Stadt',
		country: 'Land',
		firstName: 'Vorname',
		lastName: 'Nachname',
		middleName: 'Zweiter Vorname',
		birthDate: 'Geburtsdatum',
		gender: 'Geschlecht',
		nationality: 'Staatsangehörigkeit',
		docType: 'Dokumententyp',
		docNumber: 'Dokumentnummer',
		docExpiryDate: 'Gültigkeitsdatum',
		loyaltyName: 'Bonusprogramm',
		loyaltyNumber: 'Bonuskartennummer',
		Passenger: 'Passagier',
		'Onboard services': 'Bordservice',
		'Latin symbols and digits': 'Lateinische Buchstaben und Ziffern',
		'Enter date in dd.mm.yyyy format': 'Bitte geben Sie ein gültiges Datum ein',
		'Incorrect date': 'Ungültiges Datum',
		'Date expired': 'Ablaufdatum überschritten',
		Edit: 'Bearbeiten',
		Required: 'Pflichtfeld',
		Passport: 'Reisepass',
		MilitaryIDCard: 'Militärische Identitätskarte',
		DocOfPassportLusing: 'Vorläufiger Personalausweis',
		'ReleaseCertificate ': 'Bescheinigung über Entlassung',
		'ServicePassport ': 'Dienstpass',
		'FederalParliamentDeputy ': 'Abgeordnetenausweis des Bundesparlaments',
		DiplomaticPassport: 'Diplomatenpass',
		InternationalPassportNotRU: 'Internationaler Reisepass',
		InternationalPassportRU: 'Internationaler Reisepass',
		InternationalPassport: 'Internationaler Reisepass',
		NationalPassport: 'Nationaler Reisepass',
		SeamanDocument: 'Seefahrerausweis',
		SeniorDocument: 'Seniorenausweis',
		BirthRegDocument: 'Geburtsurkunde',
		CertificateOfConvictedVacation: 'Identitätsnachweis',
		ResidencePermit: 'Aufenthaltserlaubnis',
		'Only letters are allowed': 'Nur Buchstaben erlaubt',
		'Phone number of the same digits is not allowed': 'Geben Sie eine gültige Telefonnummer ein',
		'Incorrect phone number': 'Geben Sie eine gültige Telefonnummer ein',
		'Min 10 digits': 'Mindestens 10 Ziffern',
		'Max 18 digits': 'Maximal 18 Ziffern',
		'Example +1234567890': 'Beispiel: +1234567890',
		'Only digits': 'Nur Ziffern',
		'11 digits': 'Geben Sie 11 Ziffern ein',
		'10 digits': 'Geben Sie 10 Ziffern ein',
		'9 digits': 'Geben Sie 9 Ziffern ein',
		'No less then 5 digits': 'Mindestens 5 Ziffern',
		'Incorrect email': 'Geben Sie eine gültige E-Mail-Adresse ein',
		'Invalid date format': 'Bitte geben Sie ein gültiges Datum ein',
		'Example: IVШЯ123123': 'Beispiel: IVШЯ123123',
		'Example: IIIШЯ352007, 5465467': 'Beispiel: IIIШЯ352007, 5465467',
		'Example: AN0123456': 'Beispiel: AN0123456',
		'Cyrillic symbols are not allowed': 'Nur lateinische Buchstaben erlaubt',
		identity: 'Passagierdaten',
		citizenship: 'Dokument',
		loyalty: 'Bonusprogramm',
		contacts: 'Kontaktdaten',
		'Don\'t have a card yet? Register now.': 'Noch keine Karte? Jetzt registrieren.',
		'Check if the input is correct': 'Überprüfen Sie die Eingabe',
		other: 'Andere',
		organizationName: 'Name der Organisation',
		personnelNumber: 'Mitarbeiternummer',
		'A subsidized fare requires all passengers on the booking to have benefits.':
			'Subventionierter Tarif erfordert, dass alle Passagiere im Buchungsvorgang Anspruch auf Vergünstigungen haben.',
		'I have a loyalty card': 'Ich habe eine Bonuskarte',
		'Don\'t have a card yet?': 'Noch keine Karte?',
		'Register now': 'Jetzt registrieren',
		Male: 'Männlich',
		Female: 'Weiblich',
		Cancel: 'Abbrechen',
		Confirm: 'Bestätigen',
		'Please, check passenger data': 'Bitte überprüfen Sie die Passagierdaten',
		promoCode: 'Promocode',
		'Passenger with disabilities': 'Passagier mit Behinderung',
		'Passengers with disabilities and other persons with reduced mobility and persons accompanying them shall board the aircraft before boarding':
			'Passagiere mit Behinderungen und weitere mobilitätseingeschränkte Personen sowie ihre Begleitpersonen müssen vor dem Einsteigen an Bord gehen.',
		'Booking details of the accompanying passenger': 'Buchungsdaten des Begleiters',
		'Fill in the fields with the booking details of the accompanying passenger over 18 years of age. Please note that the flight dates, flight and class of service for both passengers must be the same.':
			'Füllen Sie die Felder mit den Buchungsdaten des Begleiters über 18 Jahre aus. Beachten Sie, dass Flugdatum, Flugnummer und Serviceklasse für beide Passagiere gleich sein müssen.',
		'I confirm that the provided ticket number and the name of the accompanying passenger are correct and valid.':
			'Ich bestätige, dass die angegebene Ticketnummer und der Name des Begleiters korrekt und gültig sind.',
		accompanyingPersonName: 'Name des Begleiters',
		accompanyingPersonTicketNumber: 'Ticketnummer',
		'13 digits': 'Geben Sie 13 Ziffern ein',
		'Select at least one service from the list below':
			'Wählen Sie mindestens eine Dienstleistung aus der Liste aus',
		linkedTraveller: 'Begleiter',
		'Popular countries': 'Beliebte Länder',
		'Other countries': 'Alle Länder'
	},
	Passengers: {
		Adults: 'Erwachsene',
		Teenagers: ' Jugendliche',
		Children: 'Kinder',
		'Latin symbols and digits': 'Lateinische Buchstaben und Ziffern',
		Infants: 'Säuglinge',
		'Infants with seat': 'Säuglinge mit Sitzplatz',
		'Young adult': 'Junge Erwachsene',
		'Senior (men)': 'Senioren (Männer) (муж)',
		'Senior (female)': 'Senioren (Frauen)',
		'12-23 years': '12-23 Jahre',
		'12-18 years': '12-18 Jahre',
		'55+ years': '55+ Jahre',
		'60+ years': '60+ Jahre',
		'12+ years': '12+ Jahre',
		'2-11 years': '2-11 Jahre',
		'Up to 2 years': 'Bis zu 2 Jahre',
		'Add other categories': 'Weitere Kategorien hinzufügen',
		'Adults over twelve years old': 'Erwachsene über zwölf Jahre',
		'Young peoples from twelve to eighteen years old': 'Junge Menschen von 12 bis 18 Jahren',
		'Children from two to eleven years old': 'Kinder von zwei bis elf Jahren',
		'Infants up to two years old, without seat': 'Säuglinge bis zwei Jahre, ohne Sitzplatz',
		'Infants up to two years old, with seat': 'Säuglinge bis zwei Jahre, mit Sitzplatz',
		'Young peoples 12-23 years old': 'Junge Menschen von 12 bis 23 Jahren',
		'Young peoples 12-18 years old': 'Junge Menschen von 12 bi18 Jahren',
		'Senior men up 60 years': 'Männer ab 60 Jahren',
		'Senior women up 55 years': 'Frauen ab 55 Jahren',
		'Please notice, you must receive your boarding passes at the airport':
			'Bitte beachten Sie, dass Sie Ihre Bordkarten nur am Flughafen erhalten können',
		'Senior men up 60 years, Senior women up 55 years': 'Senioren Männer ab 60 Jahren, Frauen ab 55 Jahren',
		Senior: 'Senioren',
		'men 60+ female 55+': 'M 60+ W 55+'
	},
	PassengerSubsidy: {
		'Subsidies not available': 'Subventionen nicht verfügbar',
		'A subsidized fare requires all passengers on the booking to have benefits.':
			'Ein subventionierter Tarif erfordert, dass alle Passagiere in der Buchung berechtigt sind.',
		'Edit passengers data': 'Passagierdaten bearbeiten',
		'New search': 'Neue Suche',
		Attention: 'Achtung'
	},
	PassengerTypes: {
		Adult: 'Erwachsener',
		Adult_0: 'Erwachsener',
		Adult_1: 'Erwachsene',
		Adult_2: 'Erwachsene',
		ADT: 'Erwachsener',
		ADT_0: 'Erwachsener',
		ADT_1: 'Erwachsene',
		ADT_2: 'Erwachsene',
		AAT: 'Erwachsener',
		AAT_0: 'Erwachsener',
		AAT_1: 'Erwachsene',
		AAT_2: 'Erwachsene',
		Child: 'Kind',
		Child_0: 'Kind',
		Child_1: 'Kindes',
		Child_2: 'Kinder',
		CLD: 'Kind',
		CLD_0: 'Kind',
		CLD_1: 'Kindes',
		CLD_2: 'Kinder',
		CNN: 'Kind',
		CNN_0: 'Kind',
		CNN_1: 'Kindes',
		CNN_2: 'Kinder',
		CTN: 'Kind',
		CTN_0: 'Kind',
		CTN_1: 'Kindes',
		CTN_2: 'Kinder',
		CHD: 'Kind',
		CHD_0: 'Kind',
		CHD_1: 'Kindes',
		CHD_2: 'Kinder',
		Infant: 'Säugling',
		Infant_0: 'Säugling',
		Infant_1: 'Säuglings',
		Infant_2: 'Säuglinge',
		INF: 'Säugling',
		INF_0: 'Säugling',
		INF_1: 'Säuglings',
		INF_2: 'Säuglinge',
		'Infant with seat': 'Säugling mit Sitzplatz',
		'Infant with seat_0': 'Säugling mit Sitzplatz',
		'Infant with seat_1': 'Säuglings mit Sitzplatz',
		'Infant with seat_2': 'Säuglinge mit Sitzplatz',
		INS: 'Säugling mit Sitzplatz',
		INS_0: 'Säugling mit Sitzplatz',
		INS_1: 'Säuglings mit Sitzplatz',
		INS_2: 'Säuglinge mit Sitzplatz',
		YTH: 'Jugendlicher',
		YTH_0: 'Jugendlicher',
		YTH_1: 'Jugendlicher',
		YTH_2: 'Jugendlicher',
		SCF: 'Rentnerin',
		SCF_0: 'Rentnerin',
		SCF_1: 'Rentnerin',
		SCF_2: 'Rentnerinnen',
		SCM: 'Rentner',
		SCM_0: 'Rentner',
		SCM_1: 'Rentners',
		SCM_2: 'Rentner',
		РВТ: 'Säugling mit Sitzplatz',
		РВТ_0: 'Säugling mit Sitzplatz',
		РВТ_1: 'Säuglings mit Sitzplatz',
		РВТ_2: 'Säuglinge mit Sitzplatz',
		SRC: 'Rentner',
		SRC_0: 'Rentner',
		SRC_1: 'Rentners',
		SRC_2: 'Rentner'
	},
	PaymentErrors: {
		'An error occurred while executing the request': 'Bei der Ausführung der Anfrage ist ein Fehler aufgetreten.',
		'Please try again later or contact a customer support service':
			'Bitte versuchen Sie es später erneut oder wenden Sie sich an den Kundensupport.',
		Error: 'Fehler',
		OK: 'OK',
		Sirena2_already_processed: 'Die Bestellung wurde bereits bezahlt.',
		Sirena2_access_denied:
			'Verbindung zum Zahlungssystem fehlgeschlagen. Wenden Sie sich an den Support und geben Sie den Fehlercode access_denied an.',
		Sirena2_system_error: 'Verbindung zum Zahlungssystem fehlgeschlagen. Bitte laden Sie die Seite neu.',
		Sirena2_fatal_error: 'Verbindung zum Zahlungssystem fehlgeschlagen. Bitte wenden Sie sich an den Support.',
		Sirena2_order_error:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode order_error an.',
		Sirena2_invalid_order:
			'Bestellung konnte nicht gefunden werden. Wenden Sie sich an den Support und geben Sie den Fehlercode invalid_order an.',
		Sirena2_pricing_error:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode pricing_error an.',
		Sirena2_booking_error:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode booking_error an.',
		Sirena2_wrong_amount: 'Ungültiger Bestellbetrag. Laden Sie die Seite neu oder wenden Sie sich an den Support.',
		Sirena2_session_error: 'Der Zahlungsvorgang konnte nicht gestartet werden. Bitte laden Sie die Seite neu.',
		Sirena2_max_attempts: 'Alle Zahlungsversuche für diese Bestellung sind aufgebraucht.',
		Sirena2_repeat_needed: 'Zahlungsvorgang kann nicht gestartet werden. Bitte laden Sie die Seite neu.',
		Sirena2_unknown_tax_source:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode unknown_tax_source an.',
		Sirena2_invalid_tax_data:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode invalid_tax_data an.',
		Sirena2_ambiguous_taxation_system:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode ambiguous_taxation_system an.',
		Sirena2_unknown_taxation_system:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode unknown_taxation_system an.',
		Sirena2_no_taxation_system:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode no_taxation_system an.',
		Sirena2_shop_commission:
			'Bestellung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode shop_commission an.',
		Sirena2_shop_status: 'Die Bestellung wurde bereits bezahlt oder storniert.',
		Sirena2_shop_common:
			'Verbindung zum Zahlungssystem fehlgeschlagen. Wenden Sie sich an den Support und geben Sie den Fehlercode shop_common an.',
		Sirena2_shop_session:
			'Verbindung zum Zahlungssystem fehlgeschlagen. Wenden Sie sich an den Support und geben Sie den Fehlercode shop_session an.',
		Sirena2_bank_network:
			'Die Bank ist vorübergehend nicht erreichbar. Laden Sie die Seite neu und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support.',
		Sirena2_bank_account: 'Ungültige Kartendaten. Bitte überprüfen Sie die Angaben und versuchen Sie es erneut.',
		'Sirena2_bank_i-prohibition':
			'Mit dieser Karte kann nicht bezahlt werden. Bitte wenden Sie sich an Ihre Bank oder verwenden Sie eine andere Karte.',
		Sirena2_system_3dsecure:
			'Kartendaten konnten nicht erkannt werden. Bitte überprüfen Sie die Angaben und versuchen Sie es erneut.',
		Sirena2_system_common:
			'Verbindung zum Zahlungssystem fehlgeschlagen. Wenden Sie sich an den Support und geben Sie den Fehlercode system_common an.',
		Sirena2_3dsecure_failed:
			'Kartendaten konnten nicht erkannt werden. Bitte überprüfen Sie die Angaben und versuchen Sie es erneut.',
		Sirena2_user_timeout:
			'Die Zahlungsfrist ist abgelaufen. Bitte laden Sie die Seite neu und versuchen Sie es erneut.',
		Sirena2_user_cancel: 'Der Vorgang wurde abgebrochen.',
		Sirena2_user_duplicate:
			'Die Zahlung konnte nicht bearbeitet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode user_duplicate an.',
		Sirena2_shop_network:
			'Verbindung zum Zahlungssystem fehlgeschlagen. Wenden Sie sich an den Support und geben Sie den Fehlercode shop_network an.',
		Sirena2_shop_price:
			'Der Zahlungsvorgang konnte nicht gestartet werden. Wenden Sie sich an den Support und geben Sie den Fehlercode shop_price an.',
		Sirena2_shop_invalid_fop: 'Diese Zahlungsmethode ist nicht verfügbar. Bitte verwenden Sie eine andere.',
		Sirena2_shop_wrong_amount:
			'Ungültiger Bestellbetrag. Laden Sie die Seite neu oder wenden Sie sich an den Support.  ',
		Sirena2_bank_funds:
			'Nicht genügend Guthaben auf dem Konto. Bitte laden Sie Ihr Konto auf oder verwenden Sie eine andere Karte.',
		Sirena2_bank_limit:
			'Das Kartenlimit für Transaktionen wurde überschritten. Bitte wenden Sie sich an Ihre Bank oder verwenden Sie eine andere Karte.',
		Sirena2_bank_common:
			'Die Bank hat die Zahlung abgelehnt. Bitte versuchen Sie es erneut oder verwenden Sie eine andere Karte. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support.',
		Sirena2_system_in_progress:
			'Die Zahlung wird bearbeitet. Bitte prüfen Sie den Bestellstatus in einigen Minuten. Wenn das Problem weiterhin besteht, wenden Sie sich an den Support.',
		Sirena2_system_fraud: 'Der Schutz vor verdächtigen Transaktionen wurde ausgelöst.'
	},
	PaymentForm: {
		Title_MoneyCarePro: 'Auf Kredit kaufen',
		Header_MoneyCarePro: 'Auf Kredit kaufen',
		Title_PayLate: 'In Raten',
		Header_PayLate: 'In Raten',
		Title_Idram: 'Über Idram bezahlen',
		Header_Idram: 'Über Idram bezahlen',
		Payment: 'Zahlung',
		Total: 'Gesamt',
		'Choose a convenient payment method': 'Wählen Sie eine bequeme Zahlungsmethode',
		'Credit or debit card': 'Online mit Karte',
		Service: 'Tickets und Dienstleistungen',
		Charge: 'Gebühren und Provisionen',
		'Pay by credit or debit card': 'Online mit Karte bezahlen',
		'Other methods': 'Andere Zahlungsmethoden',
		'In the next step you will be taken to a Google Pay page.':
			'Im nächsten Schritt werden Sie zur Google-Pay-Zahlungsseite weitergeleitet.',
		'Test payment': 'Testzahlung',
		'Edit order': 'Bestellung ändern',
		Instalment: 'In Raten',
		Aeroexpress: 'Aeroexpress',
		Airticket: 'Tickets',
		Baggage: 'Gepäck',
		Insurance: 'Versicherung',
		BusinessLounge: 'Business-Lounge',
		Businesslounge: 'Business-Lounge',
		Vip: 'VIP-Services',
		Meals: 'Verpflegung',
		'Please, click «Edit Order» after successful payment in Kaspi.kz APP to open your order.':
			'Nach erfolgreicher Zahlung in der Kaspi.kz-App kehren Sie zur Bestellung zurück, indem Sie auf „Bestellung ändern“ klicken.',
		Seats: 'Sitzplätze',
		'Failed to get billing code': 'Zahlungscode konnte nicht abgerufen werden',
		Invoicebox: 'Invoicebox',
		FPS: 'Schnellzahlungssystem',
		SberPay: 'SberPay',
		'Payment code': 'Zahlungscode',
		Pay: 'Bezahlen',
		'Problems with payment?': 'Probleme bei der Zahlung?',
		'Payment by QIWI': 'Über QIWI bezahlen',
		'Payment problems hint':
			'    Falls kein Pop-up-Fenster zur Eingabe Ihrer Kartendaten erscheint, versuchen Sie, die Seite neu zu laden.',
		'Please, click «Edit Order» after successful payment in QIWI app to open your order.':
			'    Nach erfolgreicher Zahlung in der QIWI-App kehren Sie zur Bestellung zurück, indem Sie auf „Bestellung ändern“ klicken.',
		'Payment by this method is temporarily unavailable, please try refreshing the page or try again later.':
			'Die Zahlung mit dieser Methode ist vorübergehend nicht möglich, bitte laden Sie die Seite neu oder versuchen Sie es später erneut.',
		'The payment with this method is unavailable.': 'Die Zahlung mit dieser Methode ist nicht verfügbar.'
	},
	PaymentProvider: {
		PayLate: 'PayLate',
		MoneyCarePro: 'MoneyCarePro'
	},
	PaymentResult: {
		'Payment successfully complete': 'Zahlung erfolgreich abgeschlossen',
		'View booking': 'Buchung anzeigen',
		'Payment has failed': 'Zahlung fehlgeschlagen',
		'Try again': 'Erneut versuchen'
	},
	PaymentTimeLimit: {
		'Booking must be completed': 'Die Buchung muss abgeschlossen werden',
		'Booking must be paid': 'Die Buchung muss bezahlt werden',
		before: 'bis',
		'today before': 'heute bis',
		'Sorry,': 'Leider,',
		'time to complete booking has expired': 'Die Zeit zum Abschluss der Buchung ist abgelaufen',
		'Repeat search': 'Suche wiederholen',
		'Cancel order': 'Bestellung stornieren'
	},
	PriceGraph: {
		'Outbound flight': 'Wählen Sie den Hinflug',
		'Return flight': 'Wählen Sie den Rückflug',
		min: 'Min',
		max: 'Max.',
		'Select month': 'Monat auswählen',
		Select: 'Auswählen',
		from: 'ab',
		'Approximate prices for 1 person for 1 direction': 'Ungefähre Preise pro Person für eine Strecke',
		'Price for 1 direction': 'Preise für eine Strecke',
		'Show flights': 'Flüge anzeigen'
	},
	PriceInMiles: {
		miles_1: 'Meile',
		miles_2: 'Meilen',
		miles_3: 'Meilen'
	},
	PriceLock: {
		'Lock this price! We will wait for you': 'Preis sichern! Wir warten auf Sie',
		'Lock it for 72 hours from just': 'Preis für 72 Stunden sichern ab nur',
		'per passenger and leg': 'pro Passagier und Strecke',
		'I want to lock the price for this flight': 'Ich möchte den Preis für diesen Flug sichern'
	},
	PromoCode: {
		'Promo code not applied': 'Promo-Code nicht angewendet',
		reset: 'zurücksetzen',
		'Do you have a promo code?': 'Haben Sie einen Promo-Code?',
		'Promo code applied': 'Promo-Code angewendet',
		'Enter a promo code': 'Geben Sie einen Promo-Code ein',
		'Promo code not applied for this flights': 'Promo-Code gilt nicht für diesen Flug',
		'Promo code': 'Promo-Code',
		Required: 'Pflichtfeld',
		'I confirm that I am an employee of Rostech. Otherwise, the Carrier has the right to cancel the ticket.':
			'Ich bestätige, dass ich Mitarbeiter von Rostech bin. Andernfalls hat der Beförderer das Recht, das Ticket zu stornieren.',
		'The number of characters must not exceed {{number}}':
			'Die Anzahl der Zeichen darf {{number}} nicht überschreiten',
		Title: 'Promocode anwenden',
		'Apply promo code': 'Promocode anwenden',
		Apply: 'Anwenden'
	},
	PromoLoader: {
		'One moment please': 'Einen Moment bitte',
		'Discover new horizons': 'Entdecken Sie neue Horizonte',
		'International flights from Kazakhstan': 'Internationale Flüge aus Kasachstan',
		Istanbul: 'Istanbul',
		Tbilisi: 'Tiflis',
		Moscow: 'Moskau',
		Xiang: 'Hubei',
		'Comfort on board': 'Komfort an Bord',
		Meal: 'Mahlzeiten',
		'Wi-Fi Connect': 'Internet an Bord',
		Fleet: 'Unsere Flotte',
		Seats: 'Sitzplätze',
		'It is safe to fly': 'Fliegen ist sicher',
		'2,000 miles giveaway!': 'Wir schenken Ihnen 2.000 Meilen!',
		'Choose your seats when booking': 'Wählen Sie Ihre Sitzplätze bei der Buchung',
		'Save up to 25% when buying extra baggage right away':
			'Sparen Sie bis zu 25 %, wenn Sie zusätzliches Gepäck direkt bei der Buchung kaufen',
		'We want to make sure your travel experience is as fun and smooth as possible also when travelling as a family. All the way from planning your trip to arriving at the airport and enjoying your time in the air, we pay special attention to your comfort.':
			'Wir möchten, dass Ihre Reise so angenehm und reibungslos wie möglich verläuft, besonders wenn Sie mit der ganzen Familie unterwegs sind. Von der Planung Ihrer Reise bis zur Ankunft am Flughafen und dem Flug selbst schenken wir Ihrem Komfort besondere Aufmerksamkeit.',
		'Every Nordwind flight is an opportunity to relax and replenish. On our local flights by Russia and flights to CIS, we serve a diverse selection of food, snacks and beverages, tailored to the time and length of your flight.':
			'Auf jedem Nordwind-Flug haben Sie die Möglichkeit, sich zu entspannen und neue Energie zu tanken. Auf unseren Inlandsflügen in Russland und Flügen in die GUS servieren wir eine vielfältige Auswahl an Speisen, Snacks und Getränken – abgestimmt auf Zeit und Dauer Ihres Fluges.',
		'The Nordwind fleet consists of over 30 aircraft. Our fleet is one the most modern in country, and thanks to it can offer you even better travel comfort on our flights.':
			'Die Nordwind-Flotte umfasst über 30 Flugzeuge. Unsere Flotte gehört zu den modernsten im Land, wodurch wir Ihnen noch mehr Reisekomfort auf unseren Flügen bieten können.',
		'Every flight is an opportunity to relax and replenish. On our local flights by Russia and flights to CIS, we serve a diverse selection of food, snacks and beverages, tailored to the time and length of your flight.':
			'Auf jedem Nordwind-Flug haben Sie die Möglichkeit, sich zu entspannen und neue Energie zu tanken. Auf unseren Inlandsflügen in Russland und Flügen in die GUS servieren wir eine vielfältige Auswahl an Speisen, Snacks und Getränken – abgestimmt auf Zeit und Dauer Ihres Fluges.',
		'The fleet consists of over 30 aircraft. Our fleet is one the most modern in country, and thanks to it can offer you even better travel comfort on our flights.':
			'Unsere Flotte umfasst über 30 Flugzeuge. Sie gehört zu den modernsten im Land und ermöglicht uns, Ihnen noch mehr Komfort auf unseren Flügen zu bieten.',
		'Flying is not a reason to refuse to communicate with family and colleagues. Wi-Fi internet on board is a unique portal to the world of entertainment and information in flight.':
			'Fliegen ist kein Grund, auf die Kommunikation mit Familie und Kollegen zu verzichten. Das WLAN an Bord ist Ihr einzigartiges Tor zur Welt der Unterhaltung und Information während des Fluges.',
		'Want to sit together or love the window seat? Do not leave the choice of place to chance.':
			'Möchten Sie zusammensitzen oder bevorzugen Sie den Fensterplatz? Überlassen Sie die Sitzplatzwahl nicht dem Zufall.',
		'From locking middle seats to completely disinfecting our aircraft, we do our best to keep you safe.':
			'Von der Blockierung der mittleren Sitzplätze über die Pflicht zum Tragen von Schutzmasken bis hin zur vollständigen Desinfektion unserer Flugzeuge – wir tun alles, um Ihre Sicherheit und Gesundheit zu gewährleisten.',
		'To thank you for your loyalty and support, we grant our club members 2,000 miles!':
			'Als Dank für Ihre Treue und Unterstützung schenken wir unseren Clubmitgliedern 2.000 Meilen!',
		'Don’t let chance affect your comfort and convenience.':
			'Überlassen Sie Ihren Komfort und Ihre Bequemlichkeit nicht dem Zufall.'
	},
	PromoMessage: {
		'Buy now - pay later': 'Jetzt fliegen – später bezahlen! 15% Cashback',
		'Learn more': 'Mehr erfahren',
		'You can buy any ticket with credit for 12 months, without an initial payment, with a grace period of 30 days.':
			'Bequeme Möglichkeit, den Ticketpreis zu sichern. Tickets erhalten Sie sofort nach der Buchung per E-Mail. Anzahlung 0 EUR.',
		'Only Citizens of the Republic of Uzbekistan and Tajikistan are allowed on the flight':
			'Zum Flug sind nur Staatsbürger der Republik Usbekistan und Tadschikistan zugelassen'
	},
	QuickSearchForm: {
		'Modify search': 'Suche ändern',
		Adult_0: 'Erwachsener',
		Adult_1: 'Erwachsene',
		Adult_2: 'Erwachsene',
		Child_0: 'Kind',
		Child_1: 'Kinder',
		Child_2: 'Kinder',
		Infant_0: 'Säugling',
		Infant_1: 'Säuglinge',
		Infant_3: 'Säuglinge',
		ADT_0: 'Erwachsener',
		ADT_1: 'Erwachsene',
		ADT_2: 'Erwachsene',
		passenger_0: 'Erwachsen',
		passenger_1: 'Erwachsene',
		passenger_2: 'Passagiere',
		МЛА_0: 'Passagier (Jugend)',
		МЛА_1: 'Passagiere (Jugend)',
		МЛА_2: 'Passagiere (Jugend)',
		SCM_0: 'Passagier (Rentner)',
		SCM_1: 'Passagiere (Rentner)',
		SCM_2: 'Passagiere (Rentner)',
		SCF_0: 'Passagier (Rentner)',
		SCF_1: 'Passagiere (Rentner)',
		SCF_2: 'Passagiere (Rentner)',
		PDA_0: 'Jugendlicher',
		PDA_1: 'Jugendliche',
		PDA_2: 'Jugendliche',
		YTH_0: 'Jugend',
		YTH_1: 'Jugend',
		YTH_2: 'Jugend',
		SRC_0: 'Senior',
		SRC_1: 'Senioren',
		SRC_2: 'Senioren',
		РВТ_0: 'Säugling mit Sitzplatz'
	},
	RecaptchaPage: {
		'You\'re not a bot, are you?': 'Sind Sie nicht etwa ein Bot?'
	},
	RecommendedBadge: {
		'Best choice': 'Beste Wahl'
	},
	Refund: {
		'I agree with the': 'Ich stimme den',
		'Terms of Service': 'Nutzungsbedingungen',
		And: 'und',
		'Privacy Policy': 'Datenschutzbestimmungen',
		New: 'Neuer Antrag',
		AllDataSaved: 'Daten gespeichert',
		Adopted: 'Antrag angenommen',
		Calculated: 'Rückerstattungsbetrag berechnet',
		ClaimReceived: 'Antrag gesendet',
		AwaitingPayment: 'Rückerstattung ausstehend',
		TimelimitExpired: 'Bestätigungsfrist abgelaufen',
		Finished: 'Abgeschlossen',
		Cancelled: 'Storniert',
		Rejected: 'Abgelehnt',
		NeedConfirm: 'Bestätigung ausstehend',
		InProcess: 'In Bearbeitung',
		'Add new request': 'Neuen Antrag erstellenу',
		Refused: 'Vom Benutzer abgelehnt',
		FlightCancellationOrDelay: 'Annullierung oder Verspätung des im Ticket angegebenen Fluges;',
		Rerouting: '  Änderung der Route (ausgenommen ungünstige Wetterbedingungen und höhere Gewalt);',
		FlightOperationOutOfSchedule: 'Flugdurchführung außerhalb des Flugplans;',
		SeatUnavailability: 'Kein Sitzplatz für den im Ticket angegebenen Flug und Termin verfügbar;',
		EnduringSecurityScreening:
			'Wenn der Passagier aufgrund einer langwierigen Sicherheitskontrolle nicht an Bord gehen kann, vorausgesetzt, dass während dieser Kontrolle keine verbotenen Substanzen oder Gegenstände gefunden werden;',
		FailedEnsureConnectionOfFlights:
			'Wenn der Beförderer die Verbindung von Flügen nicht sicherstellt, vorausgesetzt, dass es sich um Einzelverbindungen handelt;',
		Illness:
			'Krankheit des Passagiers oder eines mitreisenden Familienmitglieds, bestätigt durch entsprechende medizinische Unterlagen, oder im Todesfall des Passagiers oder eines Familienmitglieds, bestätigt durch entsprechende Unterlagen, sofern dies vor Ablauf der im Ticket angegebenen Check-in-Zeit gemeldet wird; Weitere Informationen zu den Anforderungen an solche medizinischen Unterlagen finden Sie hier;',
		FailedToProvideServices:
			'Wenn der Beförderer dem Passagier nicht die im Ticket angegebene Serviceklasse bereitstellt;',
		FailedToIssueTicketAppropriately:
			'Wenn der Beförderer oder sein bevollmächtigter Agent das Ticket nicht ordnungsgemäß ausgestellt hat;',
		OtherCases: 'In anderen Fällen, in denen der Passagier aufgrund des Beförderers nicht befördert wird;',
		MedicalCertificate: 'Ärztliches Attest',
		Request: 'Antrag',
		Create: 'ist erstellt',
		'Your comments': 'Ihre Kommentare',
		'Refund amount': 'Rückerstattungsbetrag',
		'Ticket price': 'Bestellpreis',
		'FareExchange penalty': 'Umbuchungsgebühr',
		Continue: 'Weiter',
		Back: 'Zurück',
		'Select passengers': 'Passagiere auswählen',
		'Choose the reason for refund': 'auswählen Sie bitte  Rückerstattungsgrund',
		'Involuntary refund': 'Unfreiwillige Rückerstattung',
		'Voluntary refund': 'Freiwillige Rückerstattung',
		'my plans have changed': 'Meine Pläne haben sich geändert',
		'Attach the required files': 'Erforderliche Dateien anhängen',
		'File format: jpg, pdf. File size: no more than 5MB':
			'Dateiformat: jpg, png, pdf, doc, docx. Dateigröße: maximal 5 MB',
		'Your name': 'Ihr Name',
		'Your email': 'Ihre E-Mail',
		'Your phone': 'Ihre Telefonnummer',
		'I agree to the': 'Ich stimme den',
		'Terms of Service and Privacy Policy': 'Nutzungsbedingungen und Datenschutzbestimmungen',
		'Create request': 'Antrag erstellen',
		'Only letters': 'Nur Buchstaben',
		Required: 'Pflichtfeld',
		'Wrong email': 'Ungültige E-Mail',
		'Wrong phone': 'Ungültige Telefonnummer',
		For: 'für',
		Files: 'Dateien',
		'Refund ticket': 'Ticket erstatten',
		'Refund restrictions': 'Einschränkungen bei der Rückerstattung',
		Note: 'Bitte beachten Sie',
		'The possibility and amount of refund will be calculated by the operator after sending the application. The answer will be sent to your E-mail and is also available on the order page.':
			'Möglichkeit und Höhe der Rückerstattung werden vom Betreiber nach Eingang des Antrags berechnet. Die Antwort wird an Ihre E-Mail gesendet und ist auch auf der Bestellseite verfügbar.',
		'After submitting the request, the seats you have selected will be canceled.':
			'Nach dem Absenden des Antrags werden die von Ihnen gewählten Plätze storniert.',
		'The money will be returned to the card used to pay for the ticket within 15 days':
			'Das Geld wird innerhalb von 15 Tagen auf die Karte zurückerstattet, mit der das Ticket bezahlt wurde.',
		Reject: 'Ablehnen',
		Confirm: 'Bestätigen',
		'The request is accepted for processing. The answer will be sent to your email and also available on the order page.':
			'Ihr Antrag wurde angenommen und wird bearbeitet. Die Antwort wird an Ihre E-Mail gesendet und ist auch auf der Bestellseite verfügbar.',
		'The request was deleted. Want to create a new request?':
			'Der Antrag wurde gelöscht. Möchten Sie einen neuen Antrag erstellen?',
		'Successful refund. Confirmation and detalization have been sent to your e-mail':
			'Die Rückerstattungsanfrage wurde erfolgreich erstellt. Ihre Buchung wird automatisch storniert. Die Rückerstattung erfolgt innerhalb von 5 bis 10 Bankarbeitstagen, abhängig von der ausstellenden Bank.',
		Ok: 'Ok',
		Yes: 'Ja',
		No: 'Nein',
		'Request for refund': 'Rückerstattungsantrag',
		'Successfully refund': 'Rückerstattung erfolgreich',
		'Delete request': 'Antrag löschen',
		FlightNumberChange: 'Änderung der Flugnummer',
		FlightRetimed: 'Flug neu terminiert',
		FlightCancelled: 'Flug storniert',
		PermanentWithdrawalOfService: 'Dauerhafte Einstellung des Dienstes',
		LaborDispute: 'Arbeitsstreit',
		Bereavement: 'Trauerfall',
		UnableToObtainNecessaryDocumentation: 'Erforderliche Dokumente nicht verfügbar',
		Strike: 'Streik',
		Weather: 'Wetterbedingungen',
		NaturalDisaster: 'Naturkatastrophe',
		UnacceptableReaccommodation: 'Unzumutbare Umbuchung',
		Refund_Passengers: 'Weiter',
		Refund_Reason: 'Weiter',
		Refund_CreateTicket: 'Weiter',
		'terms of tariff': 'Tarifbedingungen',
		'Back to order': 'Zurück zur Bestellung',
		'To make an exchange please contact a customer support service':
			'Für eine Rückerstattung wenden Sie sich bitte an den Kundendienst',
		'Oops...': 'Ups...',
		'View related booking': 'Zugehörige Buchung anzeigen',
		'It is not possible to refund a ticket that has been checked-in for a flight':
			'Eine Rückerstattung eines eingecheckten Tickets ist nicht möglich',
		'If you wish to make a refund, please cancel your flight check-in.':
			'Wenn Sie eine Rückerstattung wünschen, stornieren Sie bitte zuerst den Flug-Check-in.',
		'You can do it yourself by going to <a href=\'{{link}}\' target=\'_blank\'>Online Registration section</a>.':
			'  Dies können Sie selbst tun, indem Sie den Bereich <a href=\'{{link}}\' target=\'_blank\'>Online-Check-in</a> aufrufen.',
		'It is not possible to refund a used ticket': 'Eine Rückerstattung eines verwendeten Tickets ist nicht möglich',
		'The ticket has been flown on, you cannot return a used ticket.':
			'Das Ticket wurde bereits genutzt, eine Rückerstattung ist nicht möglich.'
	},
	RegisteredPassenger: {
		Economy: 'Economy-Klasse Tarif ',
		Business: 'Business-Klasse Tarif',
		First: 'Erste-Klasse Tarif',
		'Download boarding pass': 'Bordkarte herunterladen',
		Download: 'Herunterladen',
		CarryOn: 'Handgepäck',
		CheckedBaggage: 'Aufgegebenes Gepäck',
		SportingEquipment: 'Sportausrüstung',
		'Select flight for download': 'auswählen Sie bitte Flug zum Herunterladen ',
		'Select flight': 'auswählen Sie bitte Flug ',
		Seats: 'Sitzplätze',
		Meal: 'Mahlzeit',
		'Cancel check-in': 'Check-in Registration stornieren',
		'Retry check-in': 'Check-in Registration erneut versuchen',
		Yes: 'Ja',
		No: 'Nein',
		'You are going to cancel online check-in for passenger {{passenger}}. Are you sure about this?':
			'Sie sind dabei, den Online-Check-in für den Passagier {{passenger}} zu stornieren. Sind Sie sicher?',
		'Send to email': 'Per E-Mail senden',
		Send: 'Senden',
		'Registration available only at airport': 'Check-in nur am Flughafen möglich',
		'You must receive the boarding pass at the airport on the registration desk.':
			'Die Bordkarte muss am Flughafen am Check-in-Schalter abgeholt werden.',
		'Send all documents to email': 'Alle Dokumente per E-Mail senden',
		Cancel: 'Abbrechen',
		'Required field': 'Pflichtfeld',
		'Please enter a valid email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
		Email: 'E-Mail-Adresse',
		'Please notice that online check-in will also be cancelled for the following passengers':
			'    Bitte beachten Sie, dass der Online-Check-in auch für die folgenden Passagiere storniert wird:',
		'Select segments to cancel': 'Flugsegmente zum Stornieren auswählen',
		'Boarding pass': 'Bordkarte'
	},
	ResendTicketsForm: {
		Email: 'E-Mail-Adresse',
		Send: 'Senden',
		Required: 'Pflichtfeld',
		'Resend booking': 'Tickets erneut senden',
		'Failed to send tickets to the specified mail, try again later':
			'Tickets konnten nicht an die angegebene E-Mail-Adresse gesendet werden, bitte versuchen Sie es später erneut',
		'Please enter a valid email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
	},
	Results: {
		'Select flight': 'Flug auswählen',
		'Select flight to on': 'Flug nach {{city}} am {{date}} bitte auswählen',
		'Monthly price': 'Für einen Monat',
		'Weekly price': 'Für eine Woche',
		Back: 'Zurück',
		Sorting: 'Sortierung',
		Filters: 'Filter',
		'Sort by': 'Sortierung',
		Arrival: 'Ankunftszeit',
		Departure: 'Abflug',
		'Best flight': 'Bester Flug',
		Price: 'Preis',
		'Flight time': 'Flugdauer',
		Returning: 'Rückflug',
		Departing: 'Hinflug',
		'You\'ve chosen': 'Ausgewählte Flüge',
		'Depart on': 'Abflug',
		'Departure time': 'Abflugzeit',
		'save up to': 'sparen Sie bis zu',
		'Sold out': 'Tickets sind Ausverkauft',
		'Show flights': 'Flüge anzeigen',
		'Unfortunately, all seats on selected flight are already sold out.':
			'Leider sind alle Plätze auf dem von Ihnen gewählten Flug bereits ausgebucht.',
		'We can offer you another flights for the same dates.':
			'Wir können Ihnen andere Flüge zu denselben Daten anbieten.',
		'Other dates': 'Andere Daten',
		'Total price': 'Gesamtpreis',
		'Want to continue booking on your computer?': 'Möchten Sie die Buchung an Ihrem Computer fortsetzen?',
		'Continue booking': 'Buchung fortsetzen',
		'Only direct flights': 'Nur Direktflüge',
		'Only business class': 'Nur Business Class',
		Ok: 'OK',
		'Show price diagram': 'Preischart anzeigen',
		'Redeem miles': 'Meilen einlösen',
		Card: 'Mit Karte bezahlen ',
		'Change card': 'Karte wechseln',
		'Pay by money': 'Mit Geld bezahlen',
		'You sure?': 'Sind Sie sicher?',
		'Delete card from your account?': 'Karte aus Ihrem Konto löschen?',
		No: 'Nein',
		Yes: 'Ja',
		Nonstop: 'Nonstop Fluge',
		'Business Class': 'Business Klasse Tarif',
		Attention: 'Achtung',
		'You are buying a separate ticket for a child. For children under 12 years old unaccompanied traveling is not allowed. On the passenger data page select who will fly with the child: enter the ticket number and the name of the accompanying person over 18 years old. Please note: both passengers must be of the same class of service.':
			'Sie kaufen ein separates Flugticket für ein Kind. Kinder unter 12 Jahren dürfen nicht ohne Begleitung von Erwachsenen reisen. Geben Sie auf der Seite mit den Passagierdaten an, wer mit dem Kind fliegen wird: Geben Sie die Ticketnummer und den Namen der begleitenden Person über 18 Jahre ein. Bitte beachten Sie: Beide Passagiere müssen in derselben Serviceklasse reisen',
		'If you still have questions, please contact the Contact Center.':
			'Wenn Sie noch Fragen haben, wenden Sie sich bitte an das Contact Center.'
	},
	RetrieveBooking: {
		'Booking ID': 'Ticketnummer, Bestellnummer oder Buchungscode',
		'Security code': 'Zugangscode oder Nachname des Passagiers',
		'Retrieve booking': 'Buchung abrufen',
		Open: 'Suchen',
		'Enter ticket number': 'Ticketnummer eingeben',
		'Enter passenger last name': 'Nachnamen des Passagiers eingeben',
		'Enter your book code or ticket number': 'Buchungscode oder Ticketnummer eingeben',
		'Incorrect value': 'Ungültiger Nachname',
		'Ticket number': 'Ticketnummer',
		'Required field': 'Pflichtfeld',
		'Please enter ticket number for passenger you would like to check-in':
			'Bitte geben Sie die Ticketnummer des Passagiers ein, den Sie einchecken möchten',
		'Order not found': 'Bestellung nicht gefunden',
		'Passenger not found': 'Passagier nicht gefunden',
		'You can find security code in your booking confirmation email':
			'Den Zugangscode finden Sie in der Buchungsbestätigungs-E-Mail',
		'The order is being paid at the moment, please try again later':
			'Die Bestellung wird gerade bezahlt, bitte versuchen Sie es später noch einmal',
		'Enter your ticket number': 'Geben Sie Ihre Ticketnummer ein',
		'Booking not found. Please, check the information entered or use your e-ticket number for identification':
			'Buchung nicht gefunden. Bitte überprüfen Sie die eingegebenen Daten oder verwenden Sie Ihre E-Ticketnummer zur Identifikation',
		'Online check-in is not available. Check-in only at the airport':
			'Online-Check-in Registrierung nicht verfügbar. Check-in nur am Flughafen'
	},
	Schedule: {
		'Where are you flying from': 'Von wo fliegen Sie ab',
		'Where are you flying to': 'Wohin fliegen Sie',
		'Is operated by': 'Wird durchgeführt von',
		'We did not find flights to the selected cities': 'Wir haben keine Flüge zu den ausgewählten Städten gefunden',
		'Please select another city or change your search. If you would like to purchase a ticket for a specific city, please contact customer service.':
			'Bitte wählen Sie eine andere Stadt oder ändern Sie Ihre Suche. Wenn Sie ein Ticket für eine bestimmte Stadt kaufen möchten, wenden Sie sich bitte an den Kundenservice.'
	},
	ScheduleForm: {
		Schedule: 'Fahrplan',
		From: 'Von',
		To: 'Nach',
		'From, enter city or country': 'Von, Stadt oder Land eingeben',
		'To, enter city or country': 'Nach, Stadt oder Land eingeben',
		'Please select {{type}} airport': 'Bitte wählen Sie den Flughafen {{type}} aus',
		'Please select different airports': 'Bitte wählen Sie verschiedene Flughäfen aus',
		arrival: 'Ankunft',
		departure: 'Abflug'
	},
	SearchForm: {
		'Enter promo code': 'Promo-Code eingeben',
		'Redeem miles': 'Meilen einlösen',
		'Set simple route': 'Kombinierte Route zusammenstellen',
		'Set multi city route': 'Mehrere Städte auswählen',
		From: 'Von',
		To: 'Nach',
		'Please select {{type}} airport': 'Bitte wählen Sie den Flughafen {{type}} aus',
		'Please select different airports': 'Bitte wählen Sie verschiedene Flughäfen aus',
		Search: 'Suchen',
		'Please select departure date': 'Bitte wählen Sie das Abflugdatum aus',
		Outbound: 'Hinflug',
		Return: 'Rückflug',
		Dates: 'Reisedaten',
		arrival: 'Ankunft',
		departure: 'Abflug',
		'From, enter city or country': 'Von Stadt oder Land eingeben',
		'To, enter city or country': 'Nach Stadt oder Land eingeben',
		passenger_0: 'Passagier',
		passenger_1: 'Passagiere',
		passenger_2: 'Passagiere',
		Passengers: 'Passagiere',
		'Other categories': 'Andere Kategorien',
		Clear: 'Löschen',
		Done: 'Fertig',
		'Enter name or code of category': 'Name oder Code der Kategorie eingeben',
		'Pay by miles': 'Mit Meilen bezahlen',
		'Please select passengers': 'Bitte wählen Sie Passagiere aus',
		'Offer hotels': 'Hotels vorschlagen',
		'Departure airport or city': 'Abflughafen oder Stadt',
		'Arrival airport or city': 'Ankunftsflughafen oder Stadt',
		Resident: 'Einwohner',
		ResidentInfo: 'Für ausländische Staatsbürger stehen die <span>Währungen EUR, USD und RUB</span> zur Verfügung'
	},
	SearchFormDatepicker: {
		Oops: 'Ups',
		'Something went wrong, please check your internet connection or come back later':
			'Etwas ist schiefgelaufen, bitte überprüfen Sie Ihre Internetverbindung oder versuchen Sie es später erneut',
		Ok: 'Ok',
		'Without back date': 'Kein Rückflug benötigt',
		Clear: 'Zurücksetzen',
		Done: 'Fertig',
		'One way': 'Einfach OneWay Fertig  ',
		'Price matrix': 'Preisvergleich',
		Calendar: 'Kalender',
		'Price graph': 'Preise für den Monat',
		Outbound: 'Hinflug',
		Return: 'Rückflug',
		'Approximate prices for 1 person for 1 direction': 'Ungefährer Preis für 1 Person für eine Richtung'
	},
	SeatMap: {
		'Less than 24 hours left before the flight': 'Weniger als 24 Stunden bis zum Abflug',
		'You can select seats using the online registration service after issuing tickets':
			'Sie können Plätze über den Online-Check-in-Service nach Ausstellung der Tickets auswählen',
		Restriction_ElderlyPerson: 'Passagiere über 65 Jahre',
		Restriction_Unaccompanied: 'Unbegleitete Kinde',
		Restriction_SeriouslyIllPeople: 'Personen mit eingeschränkter Mobilität',
		Restriction_DoNotSpeakTheLanguage: 'Passagiere, die die Sprache der Crew nicht sprechen',
		Restriction_EscortedChildren: 'Unbegleitete Kinder',
		Restriction_Infant: 'Passagiere mit Säuglingen',
		Restriction_NeedOxygenEquipment: 'Passagiere, die spezielle Sauerstoffgeräte benötigen',
		Restriction_PassengersOnStretchers: 'Mobilitätseingeschränkte Passagiere und Personen mit Behinderungen',
		Restriction_PassengersUnder18: 'Personen unter 18 Jahren',
		Restriction_PregnantWomen: 'Schwangere Frauen',
		Restriction_RequiringAccompany: 'Passagiere, die Begleitung benötigen',
		Restriction_VisuallyOrHearingImpaired: 'Passagiere mit Seh- oder Hörbehinderung',
		Restriction_WithAnimals: 'Passagiere mit Tieren an Bord',
		'This seat is forbidden for': 'Dieser Sitz ist verboten für',
		select: 'auswählen',
		'not available': 'nicht verfügbar',
		'Unfortunately, seat selection on this flight is not available.':
			'Leider ist die Sitzplatzwahl für diesen Flug nicht verfügbar.',
		'Next flight': 'Nächster Flug',
		'Reserved seat': 'Reservierter Sitz',
		'90% on the left side': 'Die Sonne wird zu 90 % auf der linken Seite sein',
		'90% on the right side': 'Die Sonne wird zu 90 % auf der rechten Seite sein',
		'Business class': 'Businessklasse',
		'Economy class': 'Economy-Klasse',
		'First class': 'Erste Klasse',
		Business: 'Businessklasse',
		Economy: 'Economy-Klasse',
		First: 'Erste Klasse',
		Exit: 'Erste Klasse',
		seat_0: '{{count}} Sitz',
		seat_1: '{{count}} Sitze',
		seat_2: '{{count}} Sitze',
		Seats: 'Sitze',
		Adult: 'Erwachsener',
		Child: 'Kind',
		Infant: 'Säugling',
		'Infant with seat': 'Säugling mit Sitzplatz',
		Free: 'Kostenlos',
		'MAIN DECK': 'Hauptdeck',
		'You can choose your preferred seats.': 'Sie können Ihre bevorzugten Plätze auswählen.',
		'UPPER DECK': 'Oberdeck',
		'Seat details': 'Platzinformationen',
		Select: 'Auswählen',
		'Select seat': 'Wählen Sie Ihre Sitzplätze',
		'Select your seats': 'Wählen Sie Ihre Sitzplätze',
		'Select passenger': 'Passagier auswählen',
		Cancel: 'Abbrechen',
		'Take this seat': 'Diesen Sitz nehmen',
		'Change seat': 'Sitzplatz wechseln',
		Recommend: 'Empfohlen',
		'Fly together!': 'Fliegen Sie zusammen!',
		'Show recommended seats': 'Empfohlene Sitze anzeigen',
		From: 'Von',
		Total: 'Gesamt',
		'Choose your seat': 'Wählen Sie Ihren Sitzplatz',
		'Choose myself': 'Selbst auswählen',
		Confirm: 'Bestätigen',
		'Recommended seats': 'Empfohlene Plätze',
		Comfort: 'Komfortabler Platz',
		Preferred: 'Bevorzugter Platz',
		Standart: 'Standardplatz',
		Clear: 'Löschen',
		'Clear all': 'Alles löschen',
		'Passenger, {{type}}': 'Passagier, {{type}}',
		'Next Flight': 'Nächster Flug',
		Back: 'Zurück',
		from: 'von',
		Done: 'Fertig',
		'The top ones get the top seats. Be on top!': 'ЛDie Besten bekommen die besten Plätze. Seien Sie dabei!',
		'If you don\'t select a seat, we\'ll automatically allocate your seats when you check-in.':
			'Wenn Sie keinen Sitzplatz wählen, werden Ihnen beim Check-in automatisch Plätze zugewiesen.',
		'Pay attention!': 'Achtung!',
		'The airline reserves the right to replace the aircraft.':
			'Die Fluggesellschaft behält sich das Recht vor, das Flugzeug zu ersetzen.',
		'In the event of an aircraft replacement, passengers who have paid for the “seat selection” service will be provided with seats on the plane that are similar in price and comfort, while maintaining the following parameters':
			'Im Falle eines Flugzeugwechsels erhalten Passagiere, die den Service „Sitzplatzauswahl“ bezahlt haben, Sitzplätze mit ähnlichem Preis und Komfort, unter Beibehaltung folgender Parameter:',
		'- Cost of services;': '- Kosten des Services;',
		'- Location of the place relative to the window / aisle;': '— Lage des Sitzplatzes zum Fenster/Gang;',
		'- Joint seating, if one was originally selected;': '— Gemeinsame Sitzplätze, falls ursprünglich ausgewählt;',
		'- Placement in the front row of the cabin, if one was originally selected.':
			'— Platzierung in der ersten Reihe der Kabine, falls ursprünglich ausgewählt.',
		'Terms & conditions': 'Geschäftsbedingungen',
		Continue: 'Weiter',
		Note: 'Hinweis',
		SeatMap_Comfort: 'Komfortplätze',
		SeatMap_Preferred: 'Bevorzugte Plätze',
		SeatMap_Standart: 'Standardplätze',
		SeatMap_Standard: 'Standardplätze',
		'Selected seat is not available': 'Ausgewählter Sitzplatz ist nicht verfügbar',
		'The passenger can select a suitable seat marked for passengers with pets on the map. The airline has the right to transfer a passenger with an animal.':
			'Der Passagier kann auf der Karte einen geeigneten Sitzplatz für Passagiere mit Haustieren wählen. Die Fluggesellschaft hat das Recht, einen Passagier mit Tier umzusetzen.',
		'This seat is allowed for': 'Dieser Sitzplatz ist erlaubt für',
		Permissions_WithAnimals: 'Passagiere mit Tieren',
		'Free seat': 'Freier Sitz',
		'Free seats': 'Freie Sitze',
		'Information for the place': 'Informationen zum Sitzplatz',
		'Chair back does not recline': 'Sitzlehne lässt sich nicht verstellen',
		'Double seat': 'Doppelplatz',
		'An extra seat can also be booked for the safe transport of valuable and fragile items such as antiques, artifacts, family heirlooms or oversized musical instruments.':
			'    Ein zusätzlicher Sitzplatz kann auch für den sicheren Transport wertvoller und zerbrechlicher Gegenstände wie Antiquitäten, Artefakte, Familienerbstücke oder übergroße Musikinstrumente gebucht werden.',
		'When choosing the «Double Seat» service, the seats previously added by the passenger will be deleted':
			'Bei Auswahl des Services „Doppelplatz“ werden zuvor hinzugefügte Sitzplätze des Passagiers gelöscht.',
		'When you select this service, it will be automatically applied to all flights of your route':
			'Bei Auswahl dieses Services wird er automatisch auf alle Flüge Ihrer Route angewendet.',
		'When the «Double Seat» service is disabled, the seats added by the passenger earlier will be deleted':
			'    Bei Deaktivierung des Services „Doppelplatz“ werden zuvor hinzugefügte Sitzplätze des Passagiers gelöscht.',
		'Seat selection': 'Sitzplatzauswahl',
		'Children under 2 years of age fly in the same seat with an adult':
			'Kinder unter 2 Jahren fliegen auf dem Schoß eines Erwachsenen',
		'Window seat': 'Fensterplatz',
		'Seat with no window': 'Sitzplatz ohne Fenster',
		'The service applies to all flights': 'Der Service gilt für alle Flüge',
		'Selected seats will be deleted': 'Ausgewählte Plätze werden gelöscht',
		'Seat next to the partition': 'Sitzplatz neben der Trennwand',
		'Comfort seat': 'Komfortplatz'
	},
	SecureAccess: {
		'Enter your access confirmation number. For security reasons, it was sent to the email you provided when creating the order.':
			'Geben Sie bitte Ihre Zugangsbestätigungsnummer ein. Aus Sicherheitsgründen wurde sie an die E-Mail gesendet, die Sie bei der Bestellung angegeben haben.',
		'Ticket / order number from e-mail': 'Ticket- oder Bestellnummer aus der E-Mail',
		'Add booking': 'Buchung hinzufügen',
		Continue: 'Fortfahren',
		'The entered code does not match the code from the email':
			'Der eingegebene Code stimmt nicht mit dem Code aus der E-Mail überein'
	},
	Segment: {
		Departure: 'Abflug',
		Flight: 'Flugnummer',
		Terminal: 'Terminal',
		Gate: 'Flugsteig',
		Boarding: 'Boarding - Einsteigen ins Flugzeug',
		'Fare rules': 'Tarifregeln',
		'Airport check-in': 'Check-in am Flughafen  ',
		'Baggage info': 'Gepäckinformationen',
		Economy: 'Economy-Klasse Tarif',
		Business: 'Business-Klasse Tarif'
	},
	SelectedPassenger: {
		Birthday: 'Geburtsdatum',
		Gender: 'Geschlecht',
		Male: 'Männlich',
		Female: 'Weiblich',
		Citizenship: 'Staatsangehörigkeit',
		Passport: 'Reisepass',
		MilitaryIDCard: 'Militärausweis',
		DocOfPassportLusing: 'Vorläufiger Personalausweis',
		DiplomaticPassport: 'Diplomatenpass',
		InternationalPassportNotRU: 'Ausländischer Reisepass',
		InternationalPassportRU: 'Ausländischer Reisepass',
		InternationalPassport: 'Ausländischer Reisepass',
		NationalPassport: 'Nationalpass',
		SeamanDocument: 'Seefahrtsbuch',
		SeniorDocument: 'Rentenausweis',
		BirthRegDocument: 'Geburtsurkunde',
		CertificateOfConvictedVacation: 'Personalausweis',
		ResidencePermit: 'Aufenthaltstitel',
		Ticket: 'Ticketnummer',
		'Add frequent flyer number for': 'Vielfliegernummer hinzufügen für',
		Add: 'Hinzufügen  ',
		'Frequent Flyer Number': 'Vielfliegernummer',
		'Add frequent flyer': 'Vielfliegerkarte hinzufügen',
		'Frequent flyer': 'Vielfliegerkarte'
	},
	SelectSegment: {
		Confirm: 'Bestätigen',
		'Check-in for flights': 'Check-in für Flüge',
		Flight: 'Flug',
		Select: 'Auswählen',
		GetTalon: 'Check-in Registrierung abgeschlossen. Bordkarte erhalten',
		GoToCheckin: 'Check-in Registrierung geöffnet. Zum Check-in'
	},
	Service: {
		from: 'ab',
		Total: 'Gesamt',
		Close: 'Schließen',
		free: 'Kostenlos',
		Done: 'Fertig',
		Clear: 'Löschen'
	},
	ServiceRecommendation: {
		'To save your time, we have selected for you the best available seats on the plane.':
			'Um Ihre Zeit zu sparen, haben wir die besten verfügbaren Sitzplätze im Flugzeug für Sie ausgewählt',
		'Seats recommendation': 'Sitzplatzeempfehlung',
		Change: 'Selbst auswählen',
		Confirm: 'Bestätigen',
		Total: 'Gesamt',
		Flight: 'Flug',
		Seats: 'Sitzplätze',
		Price: 'Preis',
		FREE: 'Kostenlos',
		Details: 'Details',
		Allergens: 'Allergene',
		'OK, thank you': 'Verstanden, klar, danke',
		'We offer you this meal': 'Dieses Gericht wird Ihnen angeboten',
		'for FREE': 'KOSTENLOS',
		'on all flight directions': 'auf allen Flugstrecken',
		'on flight directions': 'auf Flugstrecken',
		'for all passengers': 'für alle Passagiere',
		'for passengers': 'für Passagiere'
	},
	ServiceWithSegments: {
		'Next flight': 'Nächster Flug'
	},
	SocialAuth: {
		'Social networks accounts': 'Konten in sozialen Netzwerken',
		'Quick login to your account': 'Schneller Login in Ihr Konto',
		'Connect another social media account': 'Ein weiteres soziales Netzwerk-Konto verbinden'
	},
	Stepbar: {
		Flights: 'Flüge',
		Seats: 'Sitzplätze',
		Baggage: 'Gepäck',
		Insurance: 'Versicherung',
		Meal: 'Verpflegung',
		Passengers: 'Passagiere',
		Extras: 'Zusatzleistungen',
		Payment: 'Zahlung',
		Order: 'Bestellung',
		'You can {{payload}}': 'Sie können {{payload}}',
		'add services': 'zusätzliche Leistungen zur Bestellung hinzufügen',
		'change dates': 'Abflugdatum ändern'
	},
	Subscriptions: {
		'You have a subscription': 'Sie haben ein Abonnement',
		'There are users in the order who are not covered by your subscription. The price of their tickets is considered without discount.':
			'In der Buchung gibt es Passagiere, die nicht in Ihrem Abonnement enthalten sind. Der Ticketpreis für diese Passagiere wird ohne Rabatt berechnet',
		'Members without Subscription': 'Passagiere ohne Abonnement',
		Passenger: 'Passagier',
		Without: 'Ohne Abonnement',
		With: 'Mit Abonnement',
		'Continue, I agree with this price': 'Fortfahren, ich bin mit dem Preis einverstanden',
		'Add passengers to subscription': 'Passagiere zum Abonnement hinzufügen',
		'Reselect services and seats': 'Leistungen und Sitze neu auswählen',
		'Do you have regular flights?': 'Fliegen Sie regelmäßig?',
		'Cut costs with a subscription': 'Mit einem Abonnement Kosten sparen',
		'View Offers': 'Angebote ansehen',
		'Seat selection and other subscription services at a reasonable price':
			'Sitzplatzwahl und andere Abonnementleistungen zu einem günstigen Preis',
		'View options': 'Optionen ansehen',
		'Subscription member': 'Im Abonnement enthalten',
		'Discounts apply to the user': 'Rabatte gelten für den Benutzer',
		formatDate: 'TT.MM.JJJJ',
		Subscribe: 'Abonnieren',
		'WebSky \nSubscription': 'Abonnement \nWebSky',
		'Your account details': 'Ihre Kontodaten',
		Plan: 'Tarif',
		'Date of end': 'Enddatum',
		'Your members': 'Ihre Mitglieder',
		from: 'von',
		Member: 'Mitglied',
		You: 'Sie',
		Remove: 'Entfernen',
		'Add member': 'Mitglied hinzufügen',
		'You can add more': 'Sie können noch {{count}} {{member}} hinzufügen',
		'Added max number of members': 'Maximale Anzahl an Mitgliedern hinzugefügt',
		member_0: 'Mitglied',
		member_1: 'Mitglieder',
		Payments: 'Zahlungen',
		'The next payment for your subscription will be {{date}}':
			'Die nächste Zahlung für Ihr Abonnement ist am {{date}} fällig',
		'Cancel auto-renewal': 'Automatische Verlängerung kündigen',
		'A unique subscription gives guaranteed discounts not only on your ticket, but also on tickets for your loved ones':
			'Ein exklusives Abonnement bietet garantierte Rabatte nicht nur auf Ihr Ticket, sondern auch auf Tickets für Ihre Angehörigen',
		'The subscriber can use the privileges both separately and together with his fellow travelers, whilefellow travelers - only together with the subscriber (personal data of passengers are indicated whensubscribing and are not subject to change).':
			'Der Abonnent kann die Vorteile sowohl allein als auch gemeinsam mit seinen Mitreisenden nutzen, während Mitreisende diese nur zusammen mit dem Abonnenten nutzen können (die persönlichen Daten der Passagiere werden bei der Anmeldung angegeben und können nicht geändert werden).',
		'Read more': 'Mehr erfahren',
		'Get a subscription': 'Abonnement abschließen',
		'Your data': 'Ihre Daten',
		firstName: 'Vorname',
		lastName: 'Nachname',
		birthDate: 'Geburtsdatum',
		latinFirstName: 'Vorname (lateinische Schrift)',
		latinLastName: 'Nachname (lateinische Schrift)',
		Required: 'Pflichtfeld',
		'Enter date in dd.mm.yyyy format': 'Geben Sie das Datum im Format TT.MM.JJJJ ein',
		'For worlds flights': 'Für internationale Flüge',
		'Add new Travel companion': 'Neuen Mitreisenden hinzufügen',
		'Add Member': 'hinzufügen {{member}}',
		Cancel: 'Abbrechen',
		'Select from Travel companions': 'Wählen Sie aus Mitreisenden',
		'Add new': 'Neue hinzufügen',
		'Please, select at least one member': 'Bitte wählen Sie mindestens einen Mitreisenden aus',
		'Choose your plan now': 'Tarif auswählen',
		'You get more cost-efficient flights + greater comfort':
			'Sie erhalten günstige Dienstleistungen und mehr Komfort',
		'Select your plan now': 'Wählen Sie Ihren Tarif',
		Popular: 'Beliebt',
		year: 'Jahr',
		Select: 'Wählen',
		'Still have questions?': 'Haben Sie noch Fragen?'
	},
	SubsidySuggestPopup: {
		'Subsidy fares': 'Subventionierte Tarife',
		'For special categories of passengers on the flight, you can choose special subsidy fares':
			'Für diesen Flug stehen subventionierte Tarife zur Verfügung. Wählen Sie Ihre Kategorie, um die Subvention zu nutzen.',
		'A special fare is available when all passengers in an order are eligible for subsidy benefits.':
			'Ein subventionierter Tarif kann nur gebucht werden, wenn alle Passagiere im Auftrag anspruchsberechtigt sind.',
		'Apply subsidy': 'Subvention nutzen',
		'Continue without subsidy': 'Ohne Subvention fortfahren',
		'Choose passengers': 'Kategorie auswählen'
	},
	Timer: {
		'Didn\'t get the code?': 'Code nicht erhalten?',
		'Resend it': 'Erneut senden',
		'Code sent': 'Code wurde gesendet',
		'You can get new code in': 'Sie können den Code erneut anfordern in',
		'Sending message': 'Code wird gesendet'
	},
	Title: {
		companyName: 'Unternehmen Websky',
		'Find tickets': 'Flugsuche',
		'Checkout order': 'Bestellung abschließen',
		Payment: 'Zahlung',
		Account: 'Mein Konto'
	},
	Toolbar: {
		Total: 'Gesamtbetrag',
		Continue: 'Weiter    ',
		Back: 'Zurück    ',
		'Oops...': 'Ups...',
		'An unexpected error has occurred during the creating order process. Please try again later or contact a customer support service.':
			'Beim Erstellen der Bestellung ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Kundenservice.',
		'OK, thank you': 'Klar, danke',
		'miles will be awared': 'Meilen werden gutgeschrieben',
		'miles will be charged': 'Meilen werden abgezogen',
		'This flight will be partially paid by miles': 'Dieser Flug wird teilweise mit Meilen bezahlt',
		'Fly with us and get miles': 'Fliegen Sie mit uns und sammeln Sie Meilen'
	},
	TransferInfo: {
		layover: 'Zwischenstopp in',
		'Change terminal': 'Terminalwechsel',
		Terminal: 'Terminal',
		Change: 'Wechsel'
	},
	translation: {
		d: 't',
		h: 'std',
		m: 'min',
		s: 'sek',
		kg: 'kg',
		'It looks like something went wrong': 'Es sieht so aus, als wäre etwas schiefgelaufen',
		'Please reload the page or start a new search':
			'Bitte laden Sie die Seite neu oder starten Sie eine neue Suche.',
		'Reload the page': 'Seite neu laden',
		Refresh: 'Aktualisieren',
		'We couldn\'t find any flights for given dates': 'Wir konnten für die angegebenen Daten keine Flüge finden',
		'Unfortunately, there are no available flights for given dates or all tickets have been already sold out. Please select another date or modify your search parameters.':
			'Leider sind für die von Ihnen gewählten Daten keine verfügbaren Flüge vorhanden oder alle Tickets sind bereits ausverkauft. Bitte wählen Sie ein anderes Datum oder passen Sie Ihre Suchparameter an.',
		'Please select another date or modify your search. If you wish to purchase a ticket for this particular date, please contact customer support.':
			'Bitte wählen Sie ein anderes Datum oder ändern Sie Ihre Suche. Wenn Sie ein Ticket für dieses spezielle Datum kaufen möchten, wenden Sie sich bitte an den Kundendienst',
		'It looks like search results are obsolete': 'Es scheint, dass die Suchergebnisse veraltet sind',
		'Please start a new search using the form above':
			'Bitte starten Sie eine neue Suche mit dem obigen Suchformular',
		'The specified cost is for all passengers and includes taxes and fees':
			'Der angegebene Preis gilt für alle Passagiere und beinhaltet Steuern und Gebühren',
		'Local time': 'Ortszeit',
		'Go to main page': 'Zur Hauptseite'
	},
	Traveller: {
		firstName: 'Vorname',
		lastName: 'Nachname',
		middleName: 'Zweiter Vorname oder Vatersname',
		birthDate: 'Geburtsdatum',
		email: 'E-Mail-Adresse',
		phone: 'Telefonnummer',
		nationality: 'Staatsangehörigkeit',
		Add: 'Hinzufügen',
		Required: 'Pflichtfeld',
		'Please enter a valid email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
		'Please enter a valid phone': 'Bitte geben Sie eine gültige Telefonnummer ein',
		'Please enter a valid date': 'Bitte geben Sie ein gültiges Datum ein',
		'FLIGHT PREFERENCES': 'FLUGPRÄFERENZEN',
		Seats: 'Sitzplatz',
		Meal: 'Mahlzeit ',
		Save: 'Speichern',
		'Remove passengers data': 'Passagierdaten entfernen',
		Cancel: 'Abbrechen',
		'Add companion': 'Reisebegleiter hinzufügen',
		'Add document': 'Dokument hinzufügen',
		'Frequent Flyer': 'Vielfliegerkarte hinzufügen',
		'Personal details': 'Persönliche Angaben',
		'An error occurred while executing the request, please try again':
			'Beim Ausführen der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.  ',
		Contacts: 'Kontaktdaten',
		'With the help of this data, we will be able to inform the fellow traveler about changes in booking, flight status, check-in time, etc. Optional data.':
			'Mit Hilfe dieser Angaben informieren wir den Mitreisenden über Änderungen an der Buchung, Flugstatus, Check-in-Zeit usw. (freiwillige Angabe).  ',
		Documents: 'Dokumente',
		'Save the details of your internal or foreign passport, this will speed up the process of purchasing tickets.':
			'Speichern Sie die Daten Ihres in- oder ausländischen Reisepasses, um den Ticketkauf zu beschleunigen.',
		'Personal info': 'Persönliche Informationen'
	},
	VipServiceSelect: {
		'Different for other flight?': 'Für jeden Flug separat festlegen',
		Cancel: 'Abbrechen',
		Confirm: 'Bestätigen',
		Total: 'Gesamt',
		from: 'ab'
	},
	VisaForm: {
		applicableCountry: 'Aufnahmestaat',
		birthPlace: 'Geburtsort',
		issueDate: 'Ausstellungsdatum des Visums',
		issuePlace: 'Ausstellungsort des Visums',
		number: 'Visanummer',
		Required: 'Pflichtfeld',
		'format error, only latin and digits': 'Fehler. Nur lateinische Buchstaben und Ziffern',
		'only latin and digits': 'Nur lateinische Buchstaben und Ziffern',
		'Enter date in dd.mm.yyyy format': 'Geben Sie ein gültiges Datum im Format TT.MM.JJJJ ein',
		'Incorrect date': 'Ungültiges Datum',
		'Latin characters only': 'Nur lateinische Buchstaben'
	},
	Voucher: {
		'E-voucher': 'E-Gutschein oder Promo-Code',
		Add: 'Hinzufügen',
		Done: 'Fertig',
		Details: 'Mehr erfahren',
		'Enter code': 'Code eingeben'
	},
	Warnings: {
		Clarification: 'Bitte beachten Sie'
	},
	YcMoroshkaFlightPrice: {
		'Moroshka available on this flight': 'Moroshka ist auf diesem Flug verfügbar',
		'Available on this flight': 'Auf diesem Flug ist verfügbar'
	},
	YcMoroshkaTariffInfo: {
		'Moroshka available on this flight': 'Das Programm ‚Moroshka‘ ist auf diesem Flug verfügbar.',
		'The «Moroshka» discount program is available on all tariffs for this flight':
			'Das ermäßigte Programm ‚Moroshka‘ ist für alle Tarife dieses Fluges verfügbar.',
		'How to check for privileges': 'Wie Sie die Ermäßigung prüfen können',
		'Choose any tariff.': 'Wählen Sie bitte einen beliebigen Tarif.',
		'Select additional services.': 'Wählen Sie bitte zusätzliche Services.',
		'Provide passenger details and check for eligibility for the «Moroshka» discount program.':
			'Geben Sie bitte die Passagierdaten ein und prüfen Sie die Verfügbarkeit der Ermäßigung im Rahmen des ‚Moroshka‘-Programms.',
		Detail: 'Mehr erfahren'
	},
	YcTravelArcticCircleProgram: {
		'Program «Trip to the Arctic Circle»': 'Programm „Reise zum Polarkreis',
		Program: 'Programm',
		'Spend a day in Salekhard - the only city on the Arctic Circle!':
			'Verbringen Sie einen Tag in Salekhard – der einzigen Stadt am Polarkreis!',
		Detail: 'Mehr erfahren'
	},
	YcTravelArcticCircleProgramLarge: {
		'Journey to the Arctic Circle': 'Reise zum Polarkreis',
		'Journey <br />to the Arctic Circle': 'Reise zum Polarkreis',
		'Participate in the tourist program': 'Nehmen Sie am Touristenprogramm teil',
		'When purchasing a ticket with a layover in Salekhard, the duration is 24 hours.':
			'Beim Kauf eines Tickets mit einem 24-stündigen Aufenthalt in Salekhard.',
		'We would like to inform you that voluntary refund/exchange of partially unused tickets is not allowed':
			'Bitte beachten Sie, dass eine freiwillige Rückgabe/Umtausch eines teilweise nicht genutzten Tickets nicht gestattet ist.',
		'Included<br/>in the ticket price': 'Inklusive<br/>im Ticketpreis',
		'Layover<br/>in Salekhard<br/>lasting 24 hours': 'Zwischenstopp<br/>in Salekhard<br/>für 24 Stunden',
		'Accommodation<br/>in the four-star<br/>hotel «Yuribey»': 'Übernachtung<br/>im Vier-Sterne-Hotel<br/>‘Yuribey’',
		'Transfer<br/>from the airport<br/>to the hotel and back':
			'Transfer<br/>vom Flughafen<br/>zum Hotel und zurück',
		'Included in the ticket price': 'Im Ticketpreis inbegriffen',
		'Layover in Salekhard lasting 24 hours': '24-stündiger Aufenthalt in Salekhard',
		'Accommodation in the four-star hotel «Yuribey»': 'Übernachtung im Vier-Sterne-Hotel ‚Yuribey‘',
		'Transfer from the airport to the hotel and back': 'Transfer vom Flughafen zum Hotel und zurück',
		'Join the tourist program «Journey to the Arctic Circle»':
			'Nehmen Sie am Touristenprogramm ‚Reise zum Polarkreis‘ teil',
		Detail: 'Mehr erfahren'
	}
};
